
// React & Router
import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import moment from "moment";
import { IoLogoWhatsapp } from "react-icons/io";

// Services
import {
  getAllDriver,
  getAllRoutes,
  getAllSupplier,
  getAllVehicleNumber,
  getLastTrip,
  handleKeyDown,
} from "_services";
import { fetchConsignorDetailsData, getConsignorListData } from "_services/accountsServices/consignorServices";
import { createNewLr, getDataLrDetails, getLorryTypeList } from "_services/accountsServices/lrServices";
import { getBranchListApi } from "_services/dropdownServices/dropdownService";

// Components
import {
  CityDropdownForTrip,
  CommonCheckbox,
  CommonDatePicker,
  CommonInput,
  CustomSelect,
  Heading,
  VehicleDropdownForTrip,
} from "components";

// Modals
import {
  AddEditLrModal,
  AddEditMarketDriver,
  AddEditOwnDriver,
  AddEditVehicleModal,
  AddEwayBillModal,
  AddLrModal,
  AddRouteModal,
  ConfirmModalFor,
  EbillExtentionModal,
  EndTripModal,
  EwayBillNewDetailsModal,
  FetchEwayBillLrModal,
  LrDetailModal,
  LrFreightModal2,
  MakeTruckAvailableModal,
  PartymessageModal,
  RoutePanningModal,
  RoutePanningWithoutLrModal,
  SelectLrModal2,
  TripInfoModal,
  VehicleTypeModal,
  YoutubeModal,
} from "modals";
import AddEditConsignor from "modals/AddEditConsignor/AddEditConsignor";
import AddEditSupplier from "modals/AddEditSupplier";
import AddPickUpDrop from "modals/AddPickUpDrop/AddPickUpDrop";

// Utils & Constants
import { Images } from "constants";
import images from "constants/images";
import { constant } from "constants";
import { UserContext } from "context";
import { addEwayWill, addTrip, sendMessageApi } from "features";
import { actionPermission, errorSchema, utils } from "helper";
import StorageService from "utils/StorageServices/StorageServices";
import LoadingChalli from "./LoadingChalli";
import "./createtripnew.css";
import FirmImg from '../../assets/img/firm.png'
import CrossCompanyFreightAlert from "./CrossCompanyFreightAlert";
import { useFetchBranch, useFetchVehicle } from "hooks";
import useFetchDropdowns from "hooks/useFetchDropdowns";
import { getAllPermissions } from "utils/permissionHelper";
import { getSupplierDetailsData } from "_services/accountsServices/supplierServices";
import { fetchOwnDriverDetailsData } from "_services/accountsServices/ownDriverServices";
import { getVehicleDetails } from "_services/accountsServices/vehicleServices";

import { getCityLocationList } from "_services/accountsServices/cityLocationService";
import Loadlrcomponent from "./Loadlrcomponent/Loadlrcomponent";
import useLoads, { validateFormLoad } from "hooks/useLoads/useLoads";
import LoadFormFields from "./Loadlrcomponent/LoadFormFields";
import { getEwayBillLrData } from "_services/accountsServices/ewayBillServices";




// ============================================================================
// INITIAL STATE DEFINITIONS
// ============================================================================

const getInitialFormState = () => ({
  company_id: StorageService.getCompanyId(),
  branch_id: "",
  dispatch_date: new Date(),
  due_date: (() => {
    const dueDate = new Date();
    dueDate.setDate(dueDate.getDate() + 2);
    return dueDate;
  })(),
  driver_id: "",
  supplier_id: "",
  vehicle_type_id: "",
  lorry_type_id: "",
  vehicle_id: "",
  start_kms: "",
  end_kms: 0,
  route_name: "",
  from_location: [],
  to_location: [],
  freight_type: 4,
  total_Freight: "",

});

const getInitialLocationState = (type) => ({
  [`${type}_city`]: "",
  [`${type}_state`]: "",
  lat: "",
  long: "",
});

const getInitialEwayState = () => ({
  eway_bill_number: "",
  start_date: new Date(),
  end_date: new Date(),
});

const getInitialFreightState = () => ({
  freight_type: 6,
  qty: "",
  rate: "",
  amount: 0,
  tds_diduction: 0,
});

const getInitialAutoMessageState = () => ({
  is_supplier: [],
  is_consignors: [],
  is_consignees: [],
});

const formObjLocation = {

  from_city: {},
  to_city: {},
}

// ============================================================================
// MAIN COMPONENT
// ============================================================================

const CreateTrip3 = () => {
  // ========== Context & Hooks ==========
  const {
    lrDetialsFrom,
    masterData,
    setLrDetialsFrom,
    dispatchIndent,
    setDispatchIndent,
    lrModalToggleForEway, setLrModalToggleForEway, setEwayBillLrData, lrPermissions, allMenu, mastersChild, youtubeVideos, setYoutubeVideos,
    ewayBillInitialData
  } = useContext(UserContext);



  const masterChildSupplier = mastersChild?.find((i) => i?.label === "Supplier");
  const masterChildDriver = mastersChild?.find((i) => i?.label === "Driver");

  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const hiddenInputRef = useRef(null);
  const prevSeparateLrSigRef = useRef("");
  // ========== Redux State ==========
  const { loading: ewayLoading } = useSelector((state) => state.trip);

  // ========== Form State ==========
  const [formValue, setFormValue] = useState(getInitialFormState());
  const [formLabelValue, setFormLabelValue] = useState(getInitialFormState());
  const [formError, setFormError] = useState("");
  const [ewayForm, setEwayForm] = useState(getInitialEwayState());
  const [formTotal, setFormTotal] = useState(getInitialFreightState());

  // ========== Location State ==========
  const [fromLoction, setFromLoction] = useState([getInitialLocationState("from")]);
  const [toLoction, setToLoction] = useState([getInitialLocationState("to")]);
  const [fromlocationValue, setFromLocatonValue] = useState([""]);
  const [tolocationValue, setToLocatonValue] = useState([""]);

  // ========== List Data State ==========
  const [branchList, setBranchList] = useState([]);
  const [consignorList, setConsignorList] = useState([]);
  const [driverList, setDriverList] = useState([]);
  const [lorryType, setLorryType] = useState([]);
  const [listOfFreight, setListOfFreight] = useState([]);
  const [freightTypeList, setFreightTypeList] = useState([]);
  const [tdsList, setTDsList] = useState([]);
  const [listofLr2, setListOfLr2] = useState([]);
  const [selectedLr2, setSelectedLr2] = useState([]);
  const [separateLr, setSeprateLr] = useState([]);
  const [challiValues, setChalliValues] = useState([]);

  // ========== Modal State ==========
  const [show, setShow] = useState(false);
  const [vehicleTypeshow, setVehicleTypeShow] = useState(false);
  const [showCreatRoute, setShowCreatRoute] = useState(false);
  const [showSelectLr, setShowSelectLr] = useState(false);
  const [confirmModalShow, setConfirmModalShow] = useState(false);
  const [ewaybillShow, setEwaybillShow] = useState(false);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showOffcanvasSupplier, setShowOffcanvasSupplier] = useState(false);
  const [showOffcanvasDriver, setShowOffcanvasDriver] = useState(false);
  const [showOffcanvasMarketDriver, setShowOffcanvasMarketDriver] = useState(false);
  const [showLrDetail, setShowLrDetail] = useState(false);
  const [showAddLR, setShowAddLR] = useState(false);
  const [selectParty, setSelectParty] = useState(false);
  const [isPickupDrop, setIsPickupDrop] = useState(false);
  const [showPrefield, setShowingPrefield] = useState(false);
  const [isAddConsignor, setIsAddConsignor] = useState(false);
  const [showEndTrip, setShowEndTrip] = useState(false);
  const [showAvailableTruck, setShowAvailableTruck] = useState(false);
  const [showBackModal, setShowBackModal] = useState(false);
  const [showWithOutLrModal, setShowWithOutLrModal] = useState(false);
  const [showOffcanvasOfSupplier, setShowOffcanvasOfSupplier] = useState(false);
  const [showOffcanvasOfDriver, setShowOffcanvasOfDriver] = useState(false);
  const [showRoutePlanning, setShowRoutePlanning] = useState(false);
  const [showRoutePlanningwithout, setShowRoutePlanningwithout] = useState(false);
  const [showTripInfo, setShowTripInfo] = useState(false);
  const [showPartyMessage, setShowPartyMessage] = useState(false);
  const [showConsigneeMessage, setShowConsigneeMessage] = useState(false);

  // ========== Other State ==========
  const [page, setPage] = useState(1);
  const [ownerShip, setOwnerShip] = useState("");
  const [callbackDataRoute, setcallbackDataRoute] = useState();
  const [vehicleTypeLabel, setVehicleTypeLabel] = useState({ label: "", value: "" });
  const [selectedLr, setSelectedLr] = useState([{ list: [] }]);
  const [loading, setLoading] = useState(false);
  const [LrDetele, setLrDetele] = useState({ item: "", outerIndex: "", innerIndex: "", title: "" });
  const [ewayBillId, setEwayBillId] = useState("");
  const [isSupplier, setIsSupplier] = useState(false);
  const [isDriver, setIsDriver] = useState(false);
  const [refreshVehicleDropdown, setRefreshVehicleDropdown] = useState(0);
  const [loadDispatch, setLoadDispatch] = useState(1);
  const [consignorLoading, setConsignorLoading] = useState({});
  const [indexOfLr, setIndexOfLr] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [totalQty, setTotal] = useState(0);
  const [lastTripDetails, setLastTripDetails] = useState();
  const [lastReading, setLastReading] = useState("");
  const [vehicleStatus, setVehicleStatus] = useState();
  const [indexofTable, setIndexofTable] = useState(0);
  const [isSupplierCheckboxDisabled, setIsSupplierCheckboxDisabled] = useState(false);
  const [sameFirm, setSameFirm] = useState(false)
  const [driverFirmId, setDriverFirmId] = useState("")
  const [formValueLocation, setFormValueLocation] = useState(formObjLocation);

  // ========== Auto Message State ==========
  const [automessage, setAutomessage] = useState(getInitialAutoMessageState());
  const [automessageSelected, setAutomessageSelected] = useState(getInitialAutoMessageState());

  // ========== Modal Config State ==========
  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    messageType: null,
    templateId: null,
    templateData: {},
    isLoading: false,
  });

  const { loads, setLoads, handleAddMoreLoads, handleRemoveLoad, clearFormLoad } = useLoads({
    listofLr2,
    setListOfLr2,
    setSelectedLr2,
    setLrDetele,
    masterData,
  });

  const {
    fetchBranch,
    fetchVehicle,
    fetchDriver,
    fetchSupplier,
    fetchloading,
    fetchError
  } = useFetchDropdowns(ownerShip, formLabelValue);


  // ========== Eway Modal States ==========
  const [showAddEwayModal, setShowAddEwayModal] = useState(false);
  const [showEwayDetail, setShowEwayDetail] = useState(false);
  const [isEwayClosing, setIsEwayClosing] = useState(false);
  const [activeLoadId, setActiveLoadId] = useState(null);

  const hasLinkPermission = getAllPermissions("/account/vehicle", allMenu, 'link');
  const hasDriverLinkPermission = getAllPermissions("/account/driver", allMenu, 'link');
  const hasSupplierLinkPermission = getAllPermissions("/account/supplier", allMenu, 'link');


  // ========== Computed Values ==========
  const visibleOptions = freightTypeList.filter(opt =>
    ['Flat Rate', 'Per QTY', 'Per KOT'].includes(opt.label)
  );

  const dropdownOptions = freightTypeList.filter(opt =>
    !['Flat Rate', 'Per QTY', 'Per KOT'].includes(opt.label)
  );

  const branchView = formLabelValue?.branch_id?.permission_at_supplier?.supplier_freight?.view == 1;


  const fetchConsignorList = async (search, page, limit) => {
    setLoading(true);
    const res = await getConsignorListData({
      company_id: StorageService.getCompanyId(),
      firm_id: StorageService.getFirmId(),
      offset: page,
      limit,
      search,
    });

    if (res?.responseCode === 200) {

      const list = await res?.data?.consignor_list?.map((el) => ({
        ...el, label: el?.name,
        value: el?._id,
        consignor_code: el?.consignor_code,
        template_no: el?.template_no,
      }))

      if (list.length == 1) {
        setFormValue((f) => ({ ...f, party: list[0] }))
      }

      setLoading(false);
      return {
        items: list,
        total: res?.data?.total_record,
      };

    } else {
      setLoading(false);
      toast.error(res?.responseMessage);
    }
  };

  const fetchCityList = async (search, page, limit) => {
    const res = await getCityLocationList({
      countryCode: "IN",
      stateCode: "",
      offset: page,
      limit,
      search,

    });
    if (res?.responseCode === 200) {
      const list = res?.data?.all_cities.map((c) => ({ ...c, _id: c.name, label: `${c.name}, ${c.stateName}` }))

      return {
        items: list,
        total: res?.data?.total_record,
      };
    } else {
      toast.error(res?.responseMessage);
    }
  };
  // ============================================================================
  // EFFECTS
  // ============================================================================

  // Initialize master data
  useEffect(() => {
    if (masterData) {
      const Tds = masterData.supplier_tds_list?.map((item) => ({
        label: item?.name,
        value: item?.id,
      }));
      const lrFreight = masterData?.contract_rate_type_list?.map((item) => ({
        label: item?.name,
        value: item?.id,
      }));
      setTDsList([...Tds]);
      setFreightTypeList(lrFreight);
    }
  }, [masterData]);

  // Calculate freight amount
  useEffect(() => {
    if (formTotal?.freight_type !== 6) {
      setFormTotal((prev) => {
        let total = Number(prev?.qty) * Number(prev?.rate) == 0
          ? ""
          : Number(prev?.qty) * Number(prev?.rate);
        return { ...prev, amount: total };
      });
    }
  }, [formTotal.rate, formTotal.qty]);

  // Reset rate and qty when freight type changes
  useEffect(() => {
    setFormTotal((prev) => ({
      ...prev,
      rate: prev.freight_type === 6 ? 0 : prev.rate || '',
      qty: prev.freight_type === 6 ? 0 : prev.qty || '',
    }));
  }, [formTotal.freight_type]);

  // Set dispatch date based on branch settings
  useEffect(() => {
    if (formLabelValue.branch_id) {
      setFormValue((pre) => ({
        ...pre,
        dispatch_date: formLabelValue?.branch_id?.dispatch_date_time == 0
          ? new Date()
          : new Date()
      }));
    }
  }, [formLabelValue.branch_id]);

  // Set supplier auto message
  useEffect(() => {
    if (formLabelValue.supplier_id?._id) {
      const supplier = {
        _id: formLabelValue.supplier_id?._id || "",
        name: formLabelValue.supplier_id?.name || "",
        mobile_no: formLabelValue.supplier_id?.contact_no || "",
        is_auto_message: formLabelValue.supplier_id?.is_auto_message || false,
      };

      setAutomessage((prev) => ({
        ...prev,
        is_supplier: [supplier],
      }));

      setAutomessageSelected((prev) => ({
        ...prev,
        is_supplier: supplier.mobile_no && supplier.is_auto_message
          ? [supplier._id]
          : [],
      }));
    }
  }, [formLabelValue.supplier_id]);

  // Handle browser back button
  useEffect(() => {
    const handlePopState = (event) => {
      event.preventDefault();
      setShowBackModal(true);
      window.history.pushState({ modalOpened: false }, "");
    };

    window.addEventListener("popstate", handlePopState);
    window.history.pushState({ modalOpened: false }, "");

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  // Fetch initial data
  useEffect(() => {
    fetchInitialData();
  }, []);

  // Handle route callback
  useEffect(() => {
    if (callbackDataRoute) {
      callbackDataRoute?.to_location?.map((user) => {
        setToLoction([...toLoction, getInitialLocationState("to")]);
      });

      setFromLoction(callbackDataRoute?.from_location);
      setToLoction(callbackDataRoute?.to_location);
      checkVal(callbackDataRoute);
      setcallbackDataRoute("");
    }
  }, [callbackDataRoute]);

  // Handle LR delete confirmation
  useEffect(() => {
    if (LrDetele.item) {
      setConfirmModalShow(true);
    }
  }, [LrDetele]);


  useEffect(() => {
    const initializeDispatchData = async () => {
      if (!dispatchIndent || !branchList?.length) return;

      const planData = dispatchIndent; // Your API returns the plan directly
      const from = planFromLoc(planData?.from_location);
      const to = planToLoc(planData?.to_location);

      if (from && to) {
        // Get complete consignor data (with contact_no and is_auto_message)
        const completeConsignorData = planData?.consignor_id || {};

        // Create a map of consignees from po_list (they have contact_no and is_auto_message)
        const consigneeMap = new Map();
        planData?.po_list?.forEach(po => {
          if (po.consignee_id?._id) {
            consigneeMap.set(po.consignee_id._id, po.consignee_id);
          }
        });

        const lrFlatList = (planData?.to_location || []).flatMap(toLoc =>
          (toLoc?.lr_list || []).map(lr => {
            const matchedFrom = (planData?.from_location || []).find(from =>
              from.from_city === lr.from_location && from.from_state === lr.from_state
            ) || {};

            // Get complete consignee data from the map
            const completeConsigneeData = consigneeMap.get(lr.consignee_id?._id) || lr.consignee_id;

            // Find matching PO from po_list to get po_number
            const matchingPo = planData?.po_list?.find(po =>
              po.po_number === lr.po_number ||
              po.po_number === lr.plan_po_number
            );

            return {
              ...lr,
              indent_number: planData.indent_number,
              // ✅ Use complete consignor data with contact_no and is_auto_message
              consignor_id: {
                ...lr.consignor_id,
                ...completeConsignorData
              },
              // ✅ Use complete consignee data from po_list
              consignee_id: completeConsigneeData,
              // Add PO data if needed
              po_list: matchingPo || {},
              from: {
                from_city: matchedFrom.from_city,
                from_state: matchedFrom.from_state,
                lat: matchedFrom.lat,
                long: matchedFrom.long
              },
              to: {
                to_city: toLoc?.to_city,
                to_state: toLoc?.to_state,
                lat: toLoc?.lat,
                long: toLoc?.long
              }
            };
          })
        );

        const vehicleStatus = planData?.vehicle_id?.vehicle_status;

        if (vehicleStatus === 1) {
          // Vehicle available - set all fields including supplier

          // ✅ Fetch supplier details if exists
          let enrichedSupplier = planData?.vehicle_id?.supplier_id;
          if (enrichedSupplier?._id) {
            try {
              const supplierRes = await getAllSupplier({
                company_id: StorageService.getCompanyId(),
                offset: 1,
                limit: 20,
                search: enrichedSupplier.name || "",
                firm_id: planData?.branch_id?.firm_id?._id || ""
              });

              if (supplierRes?.responseCode === 200 && supplierRes?.data?.supplier_list?.length) {
                const foundSupplier = supplierRes.data.supplier_list.find(s => s._id === enrichedSupplier._id);
                if (foundSupplier) {
                  enrichedSupplier = foundSupplier;
                }
              }
            } catch (error) {
              console.error("Failed to fetch supplier details:", error);
            }
          }

          const vehicleFirmId = planData?.vehicle_id?.firm_id?._id;
          const driverFirmId = planData?.vehicle_id?.driver_id?.firm_id?._id;
          const supplierFirmId = enrichedSupplier?.firm_id?._id;
          const branchFirmId = planData?.branch_id?.firm_id?._id;

          setFormValue(prev => ({
            ...prev,
            branch_id: planData?.branch_id?._id,
            route_name: `${from}-${to}`,
            vehicle_type_id: planData?.vehicle_type_id?._id,
            vehicle_id: planData?.vehicle_id?._id || "",
            lorry_type_id: planData?.lorry_type_id?._id,
            supplier_id: branchFirmId === supplierFirmId ? planData?.vehicle_id?.supplier_id?._id || "" : "",
            driver_id: vehicleFirmId === driverFirmId ? planData?.vehicle_id?.driver_id?._id || "" : "",
          }));

          setOwnerShip(planData?.vehicle_id?.vehicle_ownership);

          setFormLabelValue(prev => ({
            ...prev,
            branch_id: branchList?.find((i) => i?._id === planData?.branch_id?._id),
            route_name: { label: `${from}-${to}`, value: `${from}-${to}` },
            vehicle_id: {
              ...planData?.vehicle_id,
              label: planData?.vehicle_id?.vehicle_no
                ? `${planData?.vehicle_id?.vehicle_no} | ${masterData?.vehicle_ownership[
                planData?.vehicle_id?.vehicle_ownership
                ]}`
                : "",
              value: planData?.vehicle_id?._id || "",
              _id: planData?.vehicle_id?._id || "",
              vehicle_no: planData?.vehicle_id?.vehicle_no || "",
              vehicle_ownership: planData?.vehicle_id?.vehicle_ownership || ""
            },
            lorry_type_id: {
              label: planData?.lorry_type_id?.lorry_type,
              value: planData?.lorry_type_id?._id,
            },
            vehicle_type_id: {
              label: planData?.vehicle_type_id?.name,
              value: planData?.vehicle_type_id?._id,
            },
            supplier_id: enrichedSupplier?._id && branchFirmId === supplierFirmId
              ? {
                ...enrichedSupplier,
                label: enrichedSupplier?.name,
                value: enrichedSupplier?._id,
              }
              : { label: "", value: "" },
            driver_id: planData?.vehicle_id?.driver_id?._id && vehicleFirmId === driverFirmId
              ? {
                ...planData?.vehicle_id?.driver_id,
                label: planData?.vehicle_id?.driver_id?.name,
                value: planData?.vehicle_id?.driver_id?._id,
              }
              : { label: "", value: "" },
          }));

          setVehicleTypeLabel({
            label: `${planData?.lorry_type_id?.lorry_type} > ${planData?.vehicle_type_id?.name}`,
            value: "",
          });
        } else {
          // Vehicle not available - set basic fields only
          setFormValue(prev => ({
            ...prev,
            branch_id: planData?.branch_id?._id,
            route_name: `${from}-${to}`,
          }));

          setOwnerShip(planData?.vehicle_id?.vehicle_ownership);

          setFormLabelValue(prev => ({
            ...prev,
            route_name: { label: `${from}-${to}`, value: `${from}-${to}` },
            branch_id: branchList?.find((i) => i?._id === planData?.branch_id?._id)
          }));

          vehicleStatusCheckFromPaln(planData);
        }

        setListOfLr2((prev) => [...prev, ...lrFlatList]);
        setSelectedLr2((prev) => [...prev, ...lrFlatList]);
      }
    };

    if (branchList?.length) initializeDispatchData();
  }, [dispatchIndent, location.pathname, branchList]);

  // Update locations when LR list changes
  // useEffect(() => {
  //   const initializeDispatchData = async () => {
  //     if (listofLr2 && listofLr2.length > 0) {
  //       setLocationsFromData(listofLr2);
  //     }
  //   };

  //   if (listofLr2 && listofLr2.length > 0) {
  //     // Extract consignor and consignee details
  //     const consignorDetails = listofLr2
  //       .filter((item) => item?.consignor_id?._id)
  //       .map((item) => ({
  //         name: item?.consignor_id?.name,
  //         _id: item?.consignor_id?._id || "",
  //         mobile_no: item?.consignor_id?.contact_no || "",
  //         is_auto_message: item?.consignor_id?.is_auto_message || false,
  //       }));

  //     const consigneeDetails = listofLr2
  //       .filter((item) => item?.consignee_id?._id)
  //       .map((item) => {
  //         console.log(item)
  //         return {
  //           name: item?.consignee_id?.name,
  //           _id: item?.consignee_id?._id || "",
  //           mobile_no: item?.consignee_id?.contact_no || "",
  //           is_auto_message: item?.consignee_id?.is_auto_message || false,
  //         }
  //       });

  //     const autoMessageConsignorIds = consignorDetails
  //       .filter((consignor) => consignor.mobile_no && consignor.is_auto_message)
  //       .map((consignor) => consignor._id);

  //     const autoMessageConsigneeIds = consigneeDetails
  //       .filter((consignee) => consignee.mobile_no && consignee.is_auto_message)
  //       .map((consignee) => consignee._id);

  //     // Remove duplicates
  //     const uniqueConsignors = [
  //       ...new Map(consignorDetails.map((item) => [item._id, item])).values(),
  //     ];

  //     const uniqueConsignees = [
  //       ...new Map(consigneeDetails.map((item) => [item._id, item])).values(),
  //     ];

  //     setAutomessage((prev) => ({
  //       ...prev,
  //       is_consignors: uniqueConsignors,
  //       is_consignees: uniqueConsignees,
  //     }));

  //     if (listofLr2.length > 0) {
  //       setAutomessageSelected((prev) => ({
  //         ...prev,
  //         is_consignors: autoMessageConsignorIds,
  //         is_consignees: autoMessageConsigneeIds,
  //       }));
  //     }
  //   }

  //   initializeDispatchData();
  // }, [listofLr2]);

  // Update locations when LR list changes
  useEffect(() => {
    const initializeDispatchData = async () => {
      if (listofLr2 && listofLr2.length > 0) {
        setLocationsFromData(listofLr2);
      }
    };

    if (listofLr2 && listofLr2.length > 0) {
      // Extract consignor and consignee details
      const consignorDetails = listofLr2
        .filter((item) => item?.consignor_id?._id)
        .map((item) => ({
          name: item?.consignor_id?.name,
          _id: item?.consignor_id?._id || "",
          mobile_no: item?.consignor_id?.contact_no || "",
          is_auto_message: item?.consignor_id?.is_auto_message || false,
        }));

      const consigneeDetails = listofLr2
        .filter((item) => item?.consignee_id?._id)
        .map((item) => ({
          name: item?.consignee_id?.name,
          _id: item?.consignee_id?._id || "",
          mobile_no: item?.consignee_id?.contact_no || "",
          is_auto_message: item?.consignee_id?.is_auto_message || false,
        }));

      // ✅ Remove duplicates using Map (based on _id)
      const uniqueConsignors = [
        ...new Map(consignorDetails.map((item) => [item._id, item])).values(),
      ];

      const uniqueConsignees = [
        ...new Map(consigneeDetails.map((item) => [item._id, item])).values(),
      ];

      // ✅ Get auto message IDs (only from unique entries)
      const autoMessageConsignorIds = uniqueConsignors
        .filter((consignor) => consignor.mobile_no && consignor.is_auto_message)
        .map((consignor) => consignor._id);

      const autoMessageConsigneeIds = uniqueConsignees
        .filter((consignee) => consignee.mobile_no && consignee.is_auto_message)
        .map((consignee) => consignee._id);



      // ✅ Set unique pa   console.log(uniqueConsignees, autoMessageConsigneeIds, uniqueConsignors)rties in automessage
      setAutomessage((prev) => ({
        ...prev,
        is_consignors: uniqueConsignors,
        is_consignees: uniqueConsignees,
      }));

      // ✅ Update selected IDs (merge with existing to avoid losing selections)
      if (listofLr2.length > 0) {
        setAutomessageSelected((prev) => {
          // Merge existing selections with new auto-message IDs
          const mergedConsignorIds = [
            ...new Set([
              ...prev.is_consignors,
              ...autoMessageConsignorIds
            ])
          ];

          const mergedConsigneeIds = [
            ...new Set([
              ...prev.is_consignees,
              ...autoMessageConsigneeIds
            ])
          ];

          // Only keep IDs that still exist in the unique lists
          const validConsignorIds = mergedConsignorIds.filter(id =>
            uniqueConsignors.some(consignor => consignor._id === id)
          );

          const validConsigneeIds = mergedConsigneeIds.filter(id =>
            uniqueConsignees.some(consignee => consignee._id === id)
          );

          return {
            ...prev,
            is_consignors: validConsignorIds,
            is_consignees: validConsigneeIds,
          };
        });
      }
    }

    initializeDispatchData();
  }, [listofLr2]);

  // Get last trip when vehicle status changes
  useEffect(() => {
    if (vehicleStatus) {

      getLastTripHandle(vehicleStatus);
    }
  }, [vehicleStatus]);

  // Update separate LR list
  // useEffect(() => {
  //   const updatedData = listofLr2.map((item) => ({
  //     ...item,
  //     consignor_Newid: item?.consignor_id?._id,
  //     freight_type: item?.lr_freight?.freight_type || 4,
  //     qty: item?.lr_freight?.qty || 0,
  //     rate: item?.lr_freight?.rate || 0,
  //     amount: item?.lr_freight?.total_freight || 0,
  //     lr_id: item?._id,
  //     selected: true,
  //   }));

  //   if (updatedData) setSeprateLr(separateSameValues(updatedData));
  // }, [listofLr2]);

  useEffect(() => {
    // ✅ Signature banao — sirf actual data change hone pe update karo
    const listSig = listofLr2
      .map(item => `${item?._id}:${item?.lr_freight?.freight_type}:${item?.lr_freight?.qty}:${item?.lr_freight?.rate}`)
      .join("|");

    const loadSig = loads
      .filter(
        l =>
          l.mode === "form" &&
          (l.party?._id || l.party?.value) &&
          l.fromLocation?.name &&
          l.toLocation?.name
      )
      .map(l => `${l.id}:${l.party?._id || l.party?.value}:${l.fromLocation?.name}:${l.toLocation?.name}`)
      .join("|");

    const combinedSig = `${listSig}__${loadSig}`;

    if (combinedSig === prevSeparateLrSigRef.current) return;
    prevSeparateLrSigRef.current = combinedSig;

    const updatedData = listofLr2.map((item) => ({
      ...item,
      consignor_Newid: item?.consignor_id?._id,
      freight_type: item?.lr_freight?.freight_type || 6,
      qty: item?.lr_freight?.qty || 0,
      rate: item?.lr_freight?.rate || 0,
      amount: item?.lr_freight?.total_freight || 0,
      lr_id: item?._id,
      selected: true,
    }));

    const formLoadData = loads
      .filter(
        l =>
          l.mode === "form" &&
          (l.party?._id || l.party?.value) &&
          l.fromLocation?.name &&
          l.toLocation?.name
      )
      .map(l => ({
        _formLoadId: l.id,
        consignor_Newid: l.party?._id || l.party?.value || "",
        consignor_id: {
          _id: l.party?._id || l.party?.value || "",
          name: l.party?.label || l.party?.name || "",
        },
        from: {
          from_city: l.fromLocation?.name || "",
          from_state: l.fromLocation?.stateName || "",
          lat: l.fromLocation?.latitude || "",
          long: l.fromLocation?.longitude || "",
        },
        to: {
          to_city: l.toLocation?.name || "",
          to_state: l.toLocation?.stateName || "",
          lat: l.toLocation?.latitude || "",
          long: l.toLocation?.longitude || "",
        },
        from_location: l.fromLocation?.name || "",
        from_state: l.fromLocation?.stateName || "",
        to_location: l.toLocation?.name || "",
        to_state: l.toLocation?.stateName || "",
        mlr_number: l.mlrNumber || "",
        invoice_number: l.invoiceNumber || "",
        eway_bill_number: l.ewayBillNumber || null,
        eway_bill_date: l.ewayStartDate || null,
        eway_expiry_date: l.ewayExpiryDate || null,
        lr_material_list:
          l.productDescription ||
            Number(l.weight) > 0 ||
            Number(l.quantity) > 0 ||
            Number(l.salesValue) > 0 ||
            Number(l.kot) > 0
            ? [{
              product_desc: l.productDescription || "",
              weight: Number(l.weight) || 0,
              weight_type: l.weight_type || 1,
              qty: Number(l.quantity) || 0,
              qty_type: l.qty_type || 1,
              amount: Number(l.salesValue) || 0,
              kot: Number(l.kot) || 0,
              name: "",
              material_code: "",
              hsn_code: null,
              material_category_id: null,
            }]
            : [],
        freight_type: l.freight_type || 6,   // ✅ load ka value, fallback 4
        qty: Number(l.qty) || 0,            // ✅ load ka value
        rate: Number(l.rate) || 0,          // ✅ load ka value
        amount: Number(l.amount) || 0,      // ✅ load ka value
        lr_id: "",
        selected: true,
      }));

    const combined = [...updatedData, ...formLoadData];
    setSeprateLr(separateSameValues(combined));
  }, [listofLr2, loads]);

  // Initialize LR details from context
  useEffect(() => {
    const initializeDispatchData = async () => {
      if (!lrDetialsFrom || !branchList.length) return;

      const findBranch = branchList.find((i) => i?._id == lrDetialsFrom?.branch_id?._id);

      setFormLabelValue((pre) => ({ ...pre, branch_id: findBranch }));
      setFormValue((pre) => ({ ...pre, branch_id: lrDetialsFrom?.branch_id?._id }));

      try {
        const object = {
          consignor_id: lrDetialsFrom?.consignor_id?._id,
          company_id: StorageService.getCompanyId(),
        };

        const res = await fetchConsignorDetailsData(object);

        if (res?.data) {
          const enrichedDetails = {
            ...lrDetialsFrom,
            consignor_id: {
              ...res.data.consignor_id,
              ...res.data.consignor
            }
          };

          setListOfLr2(prev => [...prev, enrichedDetails]);
          setSelectedLr2(prev => [...prev, lrDetialsFrom]);
        } else {
          setListOfLr2(prev => [...prev, lrDetialsFrom]);
          setSelectedLr2(prev => [...prev, lrDetialsFrom]);
        }
      } catch (error) {
        console.error("Failed to fetch consignor details:", error);
      } finally {
        setLrDetialsFrom("");
      }
    };

    initializeDispatchData();
  }, [lrDetialsFrom, branchList]);


  // ============================================================================
  // HELPER FUNCTIONS
  // ============================================================================

  const planFromLoc = (loc) => {
    return loc?.map((item) => item.from_city).join(" + ");
  };

  const planToLoc = (loc) => {
    return loc?.map((item) => item.to_city).join(" + ");
  };

  const extractFromLocations = (data) => {
    const fromLocations = data.map(item => ({
      from_city: item.from.from_city,
      from_state: item.from.from_state,
      lat: item.from.lat,
      long: item.from.long,
    }));

    return fromLocations.filter((location, index, self) =>
      index === self.findIndex(l =>
        l.from_city === location.from_city && l.from_state === location.from_state
      )
    );
  };

  const extractToLocations = (data) => {
    const toLocations = data.map(item => ({
      to_city: item.to.to_city,
      to_state: item.to.to_state,
      lat: item.to.lat,
      long: item.to.long,
    }));

    return toLocations.filter((location, index, self) =>
      index === self.findIndex(l =>
        l.to_city === location.to_city && l.to_state === location.to_state
      )
    );
  };

  const setLocationsFromData = (data) => {
    const fromLocs = extractFromLocations(data);
    const toLocs = extractToLocations(data);
    setFromLoction(fromLocs);
    setToLoction(toLocs);
  };

  const separateSameValues = (arr) => {
    return arr;
  };

  // const mergeFreightData = (listOfLr, toLocation) => {
  //   return toLocation.map((toLoc) => {

  //     const lr_freight = listOfLr.flatMap((consignorData) => {
  //       const matchingLrs = (consignorData?.lr_list || []).filter(
  //         (lr) => lr?.to_location === toLoc?.to_city
  //       );

  //       if (matchingLrs.length === 0) return [];

  //       const chargeable_on = consignorData?.contract?.chargeable_on;

  //       return matchingLrs.map((lr) => {
  //         // ✅ chargeable_on === 1 → lr_freight se, baaki → contract_rates se
  //         const source = chargeable_on === 1 ? lr?.lr_freight : lr?.contract_rates;

  //         return {
  //           consignor_id: lr?.consignor_id?._id || '',
  //           eway_bill_number: lr?.eway_bill_number || '',
  //           eway_bill_date: lr?.eway_bill_date || '',
  //           eway_expiry_date: lr?.eway_expiry_date || '',
  //           freight_type: source?.freight_type,
  //           qty: source?.qty || 0,
  //           rate: source?.rate || 0,
  //           amount: source?.total_freight || 0,
  //           lr_id: lr?._id || ''
  //         };
  //       });
  //     });

  //     return {
  //       to_city: toLoc?.to_city,
  //       to_state: toLoc?.to_state,
  //       lat: String(toLoc?.lat),
  //       long: String(toLoc?.long),
  //       lr_freight
  //     };
  //   });
  // };

  const mergeFreightData = (listOfLr, toLocation) => {
    return toLocation.map((toLoc) => {

      const lr_freight = listOfLr.flatMap((consignorData) => {
        const matchingLrs = (consignorData?.lr_list || []).filter(
          (lr) => lr?.to_location === toLoc?.to_city
        );

        if (matchingLrs.length === 0) return [];

        const chargeable_on = consignorData?.contract?.chargeable_on;

        return matchingLrs.map((lr) => {
          const source = chargeable_on === 1 ? lr?.lr_freight : lr?.contract_rates;

          console.log(source)

          // ✅ _id hai → purana payload
          if (lr?._id) {
            return {
              consignor_id: lr?.consignor_id?._id || '',
              eway_bill_number: lr?.eway_bill_number || '',
              eway_bill_date: lr?.eway_bill_date || '',
              eway_expiry_date: lr?.eway_expiry_date || '',
              freight_type: source?.freight_type,
              qty: source?.qty || 0,
              rate: source?.rate || 0,
              amount: source?.total_freight || 0,
              lr_id: lr?._id || '',
            };
          }

          // ✅ _id nahi → naya payload with extra fields
          const lrFromList = listofLr2.find(l => l === lr) || lr;
          const materialList = (lrFromList?.lr_material_list || []).map((el) => ({
            product_desc: el?.product_desc || "",
            name: el?.product_desc || el?.name || "",
            material_code: el?.material_code || "",
            hsn_code: el?.hsn_code || null,
            material_category_id: el?.material_category_id || null,
            qty: Number(el?.qty) || 0,
            qty_type: el?.qty_type || 1,
            weight: Number(el?.weight) || 0,
            weight_type: el?.weight_type || 1,
            kot: Number(el?.kot) || 0,
            amount: Number(el?.amount) || 0,
          }));

          return {
            consignor_id: lrFromList?.consignor_id?._id || '',
            lr_id: '',

            // Eway fields
            eway_bill_number: lrFromList?.eway_bill_number || "",
            eway_bill_date: lrFromList?.eway_bill_date || "",
            eway_expiry_date: lrFromList?.eway_expiry_date || "",

            // Document fields
            invoice_number: lrFromList?.invoice_number || "",
            mlr_number: lrFromList?.mlr_number || "",

            // Material list
            lr_material_list: materialList,

            // Totals
            total_qty: materialList.reduce((s, e) => s + (Number(e.qty) || 0), 0),
            total_weight: materialList.reduce((s, e) => s + (Number(e.weight) || 0), 0),
            total_kot: materialList.reduce((s, e) => s + (Number(e.kot) || 0), 0),
            total_amount: materialList.reduce((s, e) => s + (Number(e.amount) || 0), 0),

            // Freight fields
            freight_type: source?.freight_type,
            qty: source?.qty || 0,
            rate: source?.rate || 0,
            amount: source?.total_freight || 0,
          };
        });
      });

      return {
        to_city: toLoc?.to_city,
        to_state: toLoc?.to_state,
        lat: String(toLoc?.lat),
        long: String(toLoc?.long),
        lr_freight
      };
    });
  };

  const isLrNumberValid = (data) => {
    for (let i = 0; i < data.length; i++) {
      const lrMandatory = data[i].consignor_id?.permission_at_dispatch?.lr_mandatory;
      const hasLrNumber = data[i].hasOwnProperty('lr_number') &&
        data[i].lr_number !== undefined &&
        data[i].lr_number !== null &&
        data[i].lr_number.trim() !== '';

      if (lrMandatory === 1 && !hasLrNumber) {
        return i;
      }
    }
    return -1;
  };

  const isLrEwayValid = (data) => {
    for (let i = 0; i < data.length; i++) {
      const ewayMandatory = data[i]?.consignor_id?.permission_at_dispatch?.eway_bill_mandatory;
      const eway = data[i]?.eway_bill_number;
      const hasEwayNumber = data[i].hasOwnProperty('eway_bill_number') &&
        eway !== undefined &&
        eway !== null &&
        String(eway).trim() !== '';

      if (ewayMandatory === 1 && !hasEwayNumber) {
        return i;
      }
    }
    return -1;
  };

  const updateEwayBillNumber = (id, newEwayBillNumber) => {
    const modifiedList = listofLr2.map((lr) => {
      if (lr._id === id?._id) {
        return {
          ...lr,
          eway_bill_number: newEwayBillNumber?.eway_bill_number,
          eway_bill_date: newEwayBillNumber?.eway_bill_date,
          eway_expiry_date: newEwayBillNumber?.eway_expiry_date,
        };
      }
      return lr;
    });

    setListOfLr2(modifiedList);
  };

  const checkVal = async () => {
    if (!!formError) {
      const validationResult = await utils.checkFormError(
        {
          ...formValue,
          toLoction: callbackDataRoute?.to_location,
          fromLoction: callbackDataRoute?.from_location,
        },
        errorSchema.createTripSchima
      );

      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };



  const fetchInitialData = async () => {
    try {
      const resBranch = await fetchBranch();
      handleListResponse(resBranch?.items, "branch", setBranchList);
    } catch (error) {
      console.error("Failed to fetch initial data:", error);
    }
  };

  const handleListResponse = (listData, labelKey, setter) => {
    const list = listData.map((i) => ({
      ...i,
      label: i[labelKey],
      value: i._id,
    }));
    setter(list);

    if (list.length === 1 && !dispatchIndent) {
      setFormValue((prev) => ({
        ...prev,
        [labelKey == "branch" ? "branch_id" : labelKey]:
          labelKey == "route_name" ? list[0]?.label : list[0].value,
      }));
      setFormLabelValue((prev) => ({
        ...prev,
        [[labelKey == "branch" ? "branch_id" : labelKey]]:
          labelKey == "route_name" ? "" : list[0],
      }));
    }
  };

  const getRouteList = () => {
    return getAllRoutes({
      company_id: StorageService.getCompanyId(),
      offset: page,
      limit: 2000,
    });
  };

  const getDataLorryTypeList = async () => {
    const res = await getLorryTypeList();
    setLorryType(res?.data?.lorry_type);
  };

  const getLastTripHandle = async (data) => {

    const res = await getLastTrip({
      company_id: StorageService.getCompanyId(),
      vehicle_id: data?._id,
    });

    if (res?.responseCode === 200) {
      setLastTripDetails(res.data?.trip);
      if (vehicleStatus?.vehicle_status == 1) {
        if (res.data?.trip?.end_kms) {
          setFormValue({ ...formValue, start_kms: res.data?.trip?.end_kms });
          setLastReading(res.data?.trip?.end_kms);
          setFormLabelValue((pre) => ({ ...pre, vehicle_id: data }))
        } else {
          setFormValue({ ...formValue, start_kms: "" });
          setLastReading("");
        }
      }
      return true;
    } else {
      toast.error(res?.responseMessage);
      return false;
    }
  };

  const getSingleVehicleData = async (id) => {

    try {
      let object = {
        vehicle_id: id,
      }
      const res = await getVehicleDetails(object);
      if (res?.responseCode == 200) {
        return res?.data?.vehicle;

      }

    } catch (error) {

    }
  }

  const getDataSupplierDetails = async (id_1) => {
    try {

      let object = {
        supplier_id: id_1,
      }
      const res = await getSupplierDetailsData(object);
      if (res?.responseCode == 200) {
        return res?.data?.supplier

      }
    } catch (error) {

    }
  }

  const getDataDriverDetails = async (id_1) => {
    try {

      let object = {
        company_id: StorageService.getCompanyId(),
        driver_id: id_1,
      }
      const res = await fetchOwnDriverDetailsData(object);
      if (res?.responseCode == 200) {
        return res?.data?.driver
      }
    } catch (error) {

    }
  }

  const getConsignorDetails = async (e, data, index, type) => {
    e.stopPropagation();
    const key = `${type}_${index}`;
    setConsignorLoading(prev => ({ ...prev, [key]: true }));
    setIndexOfLr(index);

    try {
      let object = {
        consignor_id: data?.consignor_id?._id,
        company_id: StorageService.getCompanyId(),
      };
      const res = await fetchConsignorDetailsData(object);

      if (res) {
        if (data._id) {
          // ✅ Edit mode — existing LR
          setShowAddLR({
            ...res.data.consignor,
            lr_id: data._id,
            isEditLr: true,
          });
        } else {
          // ✅ New LR — pre-fill data bhi merge karo
          setShowAddLR({
            ...res.data.consignor,   // consignor permissions, firm_id etc
            ...data,                  // from/to/mlr/invoice/lr_material_list etc
            lr_id: "",
            isEditLr: false,          // ✅ false rakho — naya LR banana hai
          });
        }
      }
    } catch (error) {
      console.error("Failed to fetch consignor details:", error);
    } finally {
      setConsignorLoading(prev => ({ ...prev, [key]: false }));
    }
  };

  const handleSendMessage = async (id) => {
    try {
      const payload = {
        trip_id: id,
        ...automessageSelected,
      };
      navigate(`/trip/addtrip/dispatched/${id}`);
      const res = await sendMessageApi(payload);
      if (res?.responseCode != 200) {
        console.error("Failed to send message");
      }
    } catch (error) {
      console.error("Failed to send message:", error);
    }
  };

  // ============================================================================
  // EVENT HANDLERS
  // ============================================================================

  const handleSelectFromButton = (opt) => {
    setSelectedOption(opt);
    handleFreightOnChange("freight_type", opt.value);
  };

  const handleSelectFromDropdown = (selected) => {
    setSelectedOption(selected);
    handleFreightOnChange("freight_type", selected.value);
  };

  const isSelected = (opt) => formTotal.freight_type === opt.value;

  const handleOnChange = async (name, value) => {

    const stateObj = {
      ...formValue,
      [name]:
        name === "branch_id" ||
          name === "driver_id" ||
          name === "supplier_id"
          ? value.value
          : name === "route_name"
            ? value.label
            : value,
    };

    if (name === "dispatch_date") {
      const dispatchDate = new Date(value);
      const dueDate = new Date(dispatchDate);
      dueDate.setDate(dispatchDate.getDate() + 2);
      stateObj["due_date"] = dueDate;
    }

    if (name === "supplier_id") {
      setFormTotal((pre) => ({ ...pre, tds_diduction: value?.tds_deduction }));
    }

    if (name === "vehicle_id") {

      const vehicleFirmId = value?.firm_id?._id;
      const driverFirmId = value?.driver_id?.firm_id?._id;
      const supplierFirmId = value?.supplier_id?.firm_id?._id;
      const branchFirmId = formLabelValue?.branch_id?.firm_id?._id

      stateObj["lorry_type_id"] = value?.lorry_type_id?._id;
      stateObj["vehicle_type_id"] = value?.vehicle_type_id_1?._id;
      stateObj["supplier_id"] = branchFirmId == supplierFirmId ? value?.supplier_id?._id : "";
      stateObj["driver_id"] = vehicleFirmId == driverFirmId ? value?.driver_id?._id : "";
      stateObj["vehicle_id"] = value?._id || "";
    }

    setFormValue(stateObj);

    if (!!formError) {
      const validationResult = await utils.checkFormError(
        {
          ...formTotal,
          ...stateObj,
          toLoction: toLoction,
          fromLoction: fromLoction,
          ownership: ownerShip,
          branchMandetry: value?.permission_at_supplier?.supplier_freight?.mandatory,
          firmFreight: value?.firm_id?.firm && formLabelValue?.vehicle_id?.vehicle_ownership != 2 && sameFirm
        },
        errorSchema.createTripSchima
      );

      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const handleFreightOnChange = async (name, value) => {

    const stateObj = {
      ...formTotal,
      [name]: Number(value),
    };
    setFormTotal(stateObj);

    if (!!formError) {
      const validationResult = await utils.checkFormError(
        {
          ...formValue,
          ...stateObj,
          toLoction: toLoction,
          fromLoction: fromLoction,
          ownership: ownerShip,
          branchMandetry: formLabelValue?.branch_id?.permission_at_supplier?.supplier_freight.mandatory
        },
        errorSchema.createTripSchima
      );
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const handleChange = async (name, value) => {
    const stateObj = {
      ...ewayForm,
      [name]: value,
    };

    setEwayForm(stateObj);
    if (!!formError) {
      const validationResult = await utils.checkFormError(
        stateObj,
        errorSchema.ewayBillSchima
      );

      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const vehicleStatusCheck = (data) => {
    if (data?.vehicle_status == 1) {
      vehicleHandleChange(data);
      setVehicleStatus(data);
      setOwnerShip(data?.vehicle_ownership);
    } else if (data?.vehicle_status == 2) {
      setVehicleStatus(data);
      setShowEndTrip(true);
    } else {
      setShowAvailableTruck(true);
      setVehicleStatus(data);
    }
  };

  const vehicleStatusCheckFromPaln = (data) => {
    if (data?.vehicle_id?.vehicle_status == 1) {
      setVehicleStatus(data?.vehicle_id);
    } else if (data?.vehicle_id?.vehicle_status == 2) {
      setVehicleStatus(data?.vehicle_id);
      setShowEndTrip(true);
    } else if (data?.vehicle_id?.vehicle_status == 3) {
      setShowAvailableTruck(true);
      setVehicleStatus(data?.vehicle_id);
    } else {
      return;
    }
  };

  const vehicleHandleChange = (data) => {

    const vehicleFirmId = data?.firm_id?._id;
    const driverFirmId = data?.driver_id?.firm_id?._id;
    const supplierFirmId = data?.supplier_id?.firm_id?._id;
    const branchFirmId = formLabelValue?.branch_id?.firm_id?._id



    setOwnerShip(data?.vehicle_ownership);
    setFormTotal((f) => ({ ...f, tds_diduction: data?.supplier_id?.tds_deduction }))

    setFormLabelValue({
      ...formLabelValue,
      vehicle_id: {
        ...data,

        label: `${data.vehicle_no} | ${masterData?.vehicle_ownership[data?.vehicle_ownership]}`,
      },
      lorry_type_id: {
        label: data?.lorry_type_id?.lorry_type || "",
        value: data?.lorry_type_id?._id || "",
      },
      vehicle_type_id: {
        label: data?.vehicle_type_id_1?.name || "",
        value: data?.vehicle_type_id_1?._id || "",
      },

      supplier_id: data?.vehicle_ownership == 2 && data?.supplier_id?._id && branchFirmId === supplierFirmId
        ? {

          ...data?.supplier_id,
          // label: data?.supplier_id?.name || "",
          // value: data?.supplier_id?._id || "",
          label: data?.supplier_id?.name,
          value: data?.supplier_id?._id,
          name: data?.supplier_id?.name,
          _id: data?.supplier_id?._id,
        }
        : { label: "", value: "" },
      // driver_id: data?.driver_id?._id
      //   ? { ...data?.driver_id, label: data?.driver_id?.name, value: data?.driver_id?._id, name: data?.driver_id?.name, _id: data?.driver_id?._id }
      //   : { label: "", value: "" },

      // ✅ Driver will only be set when firm matches
      driver_id:
        data?.driver_id?._id && vehicleFirmId === driverFirmId
          ? {
            ...data?.driver_id,
            label: data?.driver_id?.name,
            value: data?.driver_id?._id,
            name: data?.driver_id?.name,
            _id: data?.driver_id?._id,
          }
          : { label: "", value: "" },
    });



    setFormTotal((pre) => ({
      ...pre,
      tds_diduction: data?.supplier_id?.tds_deduction
    }));

    handleOnChange("vehicle_id", data);

    setVehicleTypeLabel({
      label: data?.lorry_type_id?.lorry_type
        ? `${data?.lorry_type_id?.lorry_type} > ${data?.vehicle_type_id_1?.name || ""}`
        : "",
      value: "",
    });
  };

  const handleDelete = () => {
    let modifyLr = [...listofLr2];
    let modifySelectedLr = [...selectedLr2];
    modifyLr.splice(LrDetele?.innerIndex, 1);
    modifySelectedLr.splice(LrDetele?.innerIndex, 1);

    setSelectedLr2(modifySelectedLr);
    setListOfLr2(modifyLr);
    toast.success("LR Removed");
    setConfirmModalShow(false);
    setLrDetele("");
  };

  const handleDelteSubmit = (e, i, innerIndex, outerIndex) => {
    e.stopPropagation();
    setLrDetele({
      ...LrDetele,
      item: i,
      innerIndex,
      outerIndex,
      title: `Load ${innerIndex + 1}`,
    });
  };

  const handleChalliChange = async (values) => {
    const total = values[20];
    setTotal(total);
    setChalliValues(values);

    if (!!formError) {
      const validationResult = await utils.checkFormError(
        {
          ...formValue,
          ...formTotal,
          toLoction: toLoction,
          fromLoction: fromLoction,
          ownership: ownerShip,
          branchMandetry: formLabelValue?.branch_id?.permission_at_supplier?.supplier_freight.mandatory,
          loadingChalliMandatory: Number(formLabelValue?.branch_id?.loading_challi?.mandatory) || 0,
          loadingChalli: values,
        },
        errorSchema.createTripSchima
      );
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const handleSupplierCheckbox = (e) => {
    const { checked } = e.target;

    const supplierId = formLabelValue?.supplier_id?._id || formValue?.supplier_id;
    const supplierNumber = formLabelValue?.supplier_id?.contact_no;
    const isAutoMessage = formLabelValue?.supplier_id?.is_auto_message;

    setAutomessageSelected((prev) => {
      let updatedSuppliers = [...prev.is_supplier];

      if (checked) {
        if (!supplierNumber) {
          // Checkbox disable karo
          setIsSupplierCheckboxDisabled(true);
          toast.error("Supplier mobile number is required!");

          // 2 second baad enable karo
          setTimeout(() => {
            setIsSupplierCheckboxDisabled(false);
          }, 5000);

          return prev;
        }

        if (!isAutoMessage) {
          // Checkbox disable karo
          setIsSupplierCheckboxDisabled(true);
          toast.error("Auto message is disabled for this supplier!");

          // 2 second baad enable karo
          setTimeout(() => {
            setIsSupplierCheckboxDisabled(false);
          }, 5000);

          return prev;
        }

        if (!updatedSuppliers.includes(supplierId)) {
          updatedSuppliers.push(supplierId);
        }
      } else {
        updatedSuppliers = updatedSuppliers.filter((id) => id !== supplierId);
      }

      return {
        ...prev,
        is_supplier: updatedSuppliers,
      };
    });
  };

  const ewayBillHandle = async (e, i) => {
    e.stopPropagation();
    try {
      let object = {
        company_id: StorageService?.getCompanyId(),
        lr_id: i?._id,
      };
      const res = await getDataLrDetails(object);

      if (res?.responseCode === 200) {
        setEwayBillId(res?.data?.lr);
        setEwayForm({
          ...ewayForm,
          start_date: new Date(res?.data?.lr?.eway_bill_date || new Date()),
          end_date: new Date(res?.data?.lr?.eway_expiry_date || new Date()),
          eway_bill_number: res?.data?.lr?.eway_bill_number,
        });
        setEwaybillShow(true);
      }
    } catch (error) {
      console.error("Failed to fetch eway bill details:", error);
    }
  };

  const handleEwayBillUpdate = async () => {
    const validationResult = await utils.checkFormError(
      { ...ewayForm },
      errorSchema.ewayBillSchima
    );

    const payload = {
      lr_id: ewayBillId?._id,
      eway_bill_number: ewayForm?.eway_bill_number,
      eway_bill_date: ewayForm?.start_date,
      eway_expiry_date: ewayForm?.end_date,
    };

    if (validationResult === true) {
      const res = await dispatch(addEwayWill(payload));

      if (res?.payload?.responseCode === 200) {
        updateEwayBillNumber(ewayBillId, res?.payload?.data?.lr);
        setEwayForm({
          ...ewayForm,
          start_date: new Date(),
          end_date: new Date(),
          eway_bill_number: "",
        });
        setEwaybillShow(false);
      } else {
        throw new Error(res?.payload?.responseMessage);
      }
    } else {
      setFormError(validationResult);
    }
  };

  const handlePermissionCallTrip = async () => {
    await actionPermission({
      company_id: StorageService.getCompanyId(),
      type: constant?.USABILITY_CONFIG_TYPES?.LR,
      onSuccess: () => {
        setTimeout(() => setSelectParty(true), 0);
      },
      setModalConfig,
    });
  };

  const handlePermissionTrip = async (e, i, index1, addLoad) => {
    await actionPermission({
      company_id: StorageService.getCompanyId(),
      type: constant?.USABILITY_CONFIG_TYPES?.LR,
      onSuccess: () => {
        setTimeout(() => getConsignorDetails(e, i, index1, addLoad), 0);
      },
      setModalConfig,
    });
  };

  const handleDetailsAction = async (data, index) => {
    setShowLrDetail(data);
    setIndexOfLr(index);
  };

  const handleNextModal = (data) => {
    setShowLrDetail(!showLrDetail);
    setShowAddLR(data);
  };

  // const onValidationCheck = async () => {
  //   const isValid = isLrNumberValid(listofLr2);
  //   const isEway = isLrEwayValid(listofLr2);

  //   const validationResult = await utils.checkFormError(
  //     {
  //       ...formValue,
  //       ...formTotal,
  //       manage_trip_kms: vehicleStatus?.manage_trip_kms,
  //       ownership: ownerShip,
  //       branchMandetry: formLabelValue?.branch_id?.permission_at_supplier?.supplier_freight?.mandatory,
  //       loadingChalliMandatory: Number(formLabelValue?.branch_id?.loading_challi?.mandatory) || 0,
  //       loadingChalli: challiValues,
  //       marketDriverMandatory: formLabelValue?.branch_id?.market_drive_on_dispatch?.mandatory,
  //       firmFreight: formLabelValue?.vehicle_id?.firm_id?.firm && formLabelValue?.vehicle_id?.vehicle_ownership != 2 && sameFirm
  //     },
  //     errorSchema.createTripSchima
  //   );

  //   if (validationResult === true) {
  //     if (loadDispatch == 0) {
  //       setShowWithOutLrModal(true);
  //     } else if (loadDispatch == 1) {
  //       if (listofLr2.length != 0) {
  //         if (isValid === -1 && isEway === -1) {
  //           const isRoutePlanningEnabled = formLabelValue?.branch_id?.route_customization_on_trip == 1;
  //           const hasFromCity = fromLoction?.[0]?.from_city;
  //           const hasToCity = toLoction?.[0]?.to_city;

  //           if (isRoutePlanningEnabled && hasFromCity && hasToCity) {
  //             setShowRoutePlanning(true);
  //           } else {
  //             setShow(true);
  //           }
  //         } else {
  //           if (isValid !== -1) {
  //             toast.error(`Please Add Mandatory Field in Load ${isValid + 1}`);
  //           } else if (isEway !== -1) {
  //             toast.error(`Please Add Mandatory Field in Load ${isEway + 1}`);
  //           }
  //         }
  //       } else {
  //         setShowWithOutLrModal(true);
  //       }
  //     }
  //   } else {
  //     setFormError(validationResult);
  //   }
  // };

  const onValidationCheck = async () => {
    const isValid = isLrNumberValid(listofLr2);
    const isEway = isLrEwayValid(listofLr2);

    const validationResult = await utils.checkFormError(
      {
        ...formValue,
        ...formTotal,
        manage_trip_kms: vehicleStatus?.manage_trip_kms,
        ownership: ownerShip,
        branchMandetry: formLabelValue?.branch_id?.permission_at_supplier?.supplier_freight?.mandatory,
        loadingChalliMandatory: Number(formLabelValue?.branch_id?.loading_challi?.mandatory) || 0,
        loadingChalli: challiValues,
        marketDriverMandatory: formLabelValue?.branch_id?.market_drive_on_dispatch?.mandatory,
        firmFreight: formLabelValue?.vehicle_id?.firm_id?.firm && formLabelValue?.vehicle_id?.vehicle_ownership != 2 && sameFirm
      },
      errorSchema.createTripSchima
    );

    if (validationResult === true) {
      // ✅ Ab sirf LR hone par hi dispatch hoga
      const hasLr = listofLr2.length > 0 || loads.some(
        l =>
          l.mode === "form" &&
          (l.party?._id || l.party?.value) &&
          l.fromLocation?.name &&
          l.toLocation?.name
      );

      if (!hasLr) {
        toast.error("Please add at least one LR before dispatching");
        return;
      }

      // ✅ Without LR modal logic comment kiya
      // if (loadDispatch == 0) {
      //   setShowWithOutLrModal(true);
      // } else if (loadDispatch == 1) {
      //   if (listofLr2.length != 0) {
      //     if (isValid === -1 && isEway === -1) {
      //       const isRoutePlanningEnabled = formLabelValue?.branch_id?.route_customization_on_trip == 1;
      //       const hasFromCity = fromLoction?.[0]?.from_city;
      //       const hasToCity = toLoction?.[0]?.to_city;
      //       if (isRoutePlanningEnabled && hasFromCity && hasToCity) {
      //         setShowRoutePlanning(true);
      //       } else {
      //         setShow(true);
      //       }
      //     } else {
      //       if (isValid !== -1) {
      //         toast.error(`Please Add Mandatory Field in Load ${isValid + 1}`);
      //       } else if (isEway !== -1) {
      //         toast.error(`Please Add Mandatory Field in Load ${isEway + 1}`);
      //       }
      //     }
      //   } else {
      //     setShowWithOutLrModal(true);
      //   }
      // }

      if (isValid === -1 && isEway === -1) {
        const isRoutePlanningEnabled = formLabelValue?.branch_id?.route_customization_on_trip == 1;
        const hasFromCity = fromLoction?.[0]?.from_city;
        const hasToCity = toLoction?.[0]?.to_city;

        if (isRoutePlanningEnabled && hasFromCity && hasToCity) {
          setShowRoutePlanning(true);
        } else {
          setShow(true);
        }
      } else {
        if (isValid !== -1) {
          toast.error(`Please Add Mandatory Field in Load ${isValid + 1}`);
        } else if (isEway !== -1) {
          toast.error(`Please Add Mandatory Field in Load ${isEway + 1}`);
        }
      }

    } else {
      setFormError(validationResult);
    }
  };

  // const onSubmit = async () => {
  //   setLoading(true);

  //   const transformLrFreight = listOfFreight.map((lrfMain) => {
  //     const contract = lrfMain?.contract || {};

  //     if (contract.highest_freight === 1 && contract.multiple_rates_allowed !== 1) {
  //       const maxAmount = Math.max(
  //         ...lrfMain.lr_list.map(item => item?.contract_rates?.total_freight || 0)
  //       );

  //       return {
  //         ...lrfMain,
  //         lr_list: lrfMain.lr_list.map((lrInner) => {
  //           const sourceRates = lrInner.contract_rates;
  //           const currentAmount = sourceRates?.total_freight || 0;
  //           return {
  //             ...lrInner,
  //             contract_rates: {
  //               ...sourceRates,
  //               total_freight: currentAmount === maxAmount ? currentAmount : 0
  //             }
  //           };
  //         })
  //       };
  //     }

  //     if (contract.highest_freight === 1 && contract.multiple_rates_allowed === 1) {
  //       return {
  //         ...lrfMain,
  //         lr_list: lrfMain.lr_list.map((lrInner) => {
  //           const sourceRates = lrInner.contract_rates;
  //           const isSelected = sourceRates?.selected;

  //           return {
  //             ...lrInner,
  //             contract_rates: {
  //               ...sourceRates,
  //               total_freight: isSelected ? sourceRates.total_freight || 0 : 0
  //             }
  //           };
  //         })
  //       };
  //     }

  //     if (contract.highest_freight !== 1 && contract.multiple_rates_allowed === 1) {
  //       return {
  //         ...lrfMain,
  //         lr_list: lrfMain.lr_list.map((lrInner) => {
  //           const sourceRates = lrInner.contract_rates;
  //           const isSelected = sourceRates?.selected;

  //           return {
  //             ...lrInner,
  //             contract_rates: {
  //               ...sourceRates,
  //               total_freight: isSelected ? sourceRates.total_freight || 0 : 0
  //             }
  //           };
  //         })
  //       };
  //     }

  //     return {
  //       ...lrfMain,
  //       lr_list: lrfMain.lr_list.map((lrInner) => ({
  //         ...lrInner,
  //         contract_rates: {
  //           ...(lrfMain?.contract
  //             ? lrInner.contract_rates
  //             : lrInner.contract_rates)
  //         }
  //       }))
  //     };
  //   });

  //   const modifyLocation = mergeFreightData(transformLrFreight, toLoction);

  //   const formateChange = (data) => {
  //     return data?.map((i) => ({
  //       ...i,
  //       lat: String(i?.lat),
  //       long: String(i?.long),
  //     }));
  //   };

  //   let payload = {
  //     branch_id: formValue?.branch_id,
  //     company_id: StorageService?.getCompanyId(),
  //     dispatch_date: utils.convertToISO(formValue?.dispatch_date, true),
  //     driver_id: formValue?.driver_id || "",
  //     end_kms: formValue?.end_kms,
  //     from_location: formateChange(fromLoction),
  //     to_location: formateChange(modifyLocation),
  //     lorry_type_id: formValue?.lorry_type_id,
  //     route_name: formValue?.route_name,
  //     start_kms: formValue?.start_kms || "",
  //     supplier_id: ownerShip == 2 ? formValue?.supplier_id : "",
  //     vehicle_id: formValue?.vehicle_id,
  //     vehicle_type_id: formValue?.vehicle_type_id,
  //     // supplier_freight: formTotal.amount == 0 || formTotal.amount == "" || ownerShip != 2
  //     //   ? null
  //     //   : formTotal,
  //     supplier_freight:
  //       (formTotal.amount == 0 ||
  //         formTotal.amount == "" ||
  //         ownerShip != 2) && !(ownerShip == 1 && sameFirm)
  //         ? null
  //         : (ownerShip == 1 && sameFirm ? formTotal : formTotal),

  //     loading_challi: challiValues,
  //     ...(dispatchIndent ? { plan_id: dispatchIndent._id } : {}),
  //   };



  //   try {
  //     const res = await dispatch(addTrip(payload));
  //     if (res?.payload?.responseCode === 200) {
  //       setLoading(false);
  //       toast.success(res?.payload?.responseMessage);
  //       setShowRoutePlanningwithout(false);
  //       setShow(false);
  //       setFormValue({ ...getInitialFormState() });
  //       setSelectedLr([]);
  //       handleSendMessage(res?.payload?.data?.trip?._id);
  //       setDispatchIndent('');
  //     } else if (res?.payload?.responseCode === 400) {
  //       // toast.error(res?.payload?.responseMessage);
  //       setLoading(false);
  //     } else {
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     setLoading(false);
  //     console.error("Failed to submit trip:", error);
  //   }
  // };


  const onSubmit = async () => {
    setLoading(true);

    // ✅ Form loads jo party+from+to filled hain unhe lr format mein convert karo
    const formLoadAsLr = loads
      .filter(
        l =>
          l.mode === "form" &&
          (l.party?._id || l.party?.value) &&
          l.fromLocation?.name &&
          l.toLocation?.name
      )
      .map(l => ({
        _formLoadId: l.id,
        consignor_id: {
          _id: l.party?._id || l.party?.value || "",
        },
        from: {
          from_city: l.fromLocation?.name || "",
          from_state: l.fromLocation?.stateName || "",
          lat: l.fromLocation?.latitude || "",
          long: l.fromLocation?.longitude || "",
        },
        to: {
          to_city: l.toLocation?.name || "",
          to_state: l.toLocation?.stateName || "",
          lat: l.toLocation?.latitude || "",
          long: l.toLocation?.longitude || "",
        },
        from_location: l.fromLocation?.name || "",
        from_state: l.fromLocation?.stateName || "",
        to_location: l.toLocation?.name || "",
        to_state: l.toLocation?.stateName || "",
        mlr_number: l.mlrNumber || "",
        invoice_number: l.invoiceNumber || "",
        eway_bill_number: l.ewayBillNumber || null,
        eway_bill_date: l.ewayStartDate || null,
        eway_expiry_date: l.ewayExpiryDate || null,
        firm_id:formLabelValue?.branch_id?.firm_id,
        lr_material_list:
          l.productDescription ||
            Number(l.weight) > 0 ||
            Number(l.quantity) > 0 ||
            Number(l.salesValue) > 0 ||
            Number(l.kot) > 0
            ? [{
              product_desc: l.productDescription || "",
              weight: Number(l.weight) || 0,
              weight_type: l.weight_type || 1,
              qty: Number(l.quantity) || 0,
              qty_type: l.qty_type || 1,
              amount: Number(l.salesValue) || 0,
              kot: Number(l.kot) || 0,
              name: "",
              material_code: "",
              hsn_code: null,
              material_category_id: null,
            }]
            : [],
      }));

    // ✅ listofLr2 + formLoadAsLr combine karo — sirf payload ke liye
    console.log("listofLr2", listofLr2, formLoadAsLr)
    const combinedLrList = [...listofLr2, ...formLoadAsLr];
    console.log("combinedLrList", combinedLrList,listOfFreight)

    const transformLrFreight = listOfFreight.map((lrfMain) => {
      const contract = lrfMain?.contract || {};

      if (contract.highest_freight === 1 && contract.multiple_rates_allowed !== 1) {
        const maxAmount = Math.max(
          ...lrfMain.lr_list.map(item => item?.contract_rates?.total_freight || 0)
        );
        return {
          ...lrfMain,
          lr_list: lrfMain.lr_list.map((lrInner) => {
            const sourceRates = lrInner.contract_rates;
            const currentAmount = sourceRates?.total_freight || 0;
            return {
              ...lrInner,
              contract_rates: {
                ...sourceRates,
                total_freight: currentAmount === maxAmount ? currentAmount : 0
              }
            };
          })
        };
      }

      if (contract.highest_freight === 1 && contract.multiple_rates_allowed === 1) {
        return {
          ...lrfMain,
          lr_list: lrfMain.lr_list.map((lrInner) => {
            const sourceRates = lrInner.contract_rates;
            const isSelected = sourceRates?.selected;
            return {
              ...lrInner,
              contract_rates: {
                ...sourceRates,
                total_freight: isSelected ? sourceRates.total_freight || 0 : 0
              }
            };
          })
        };
      }

      if (contract.highest_freight !== 1 && contract.multiple_rates_allowed === 1) {
        return {
          ...lrfMain,
          lr_list: lrfMain.lr_list.map((lrInner) => {
            const sourceRates = lrInner.contract_rates;
            const isSelected = sourceRates?.selected;
            return {
              ...lrInner,
              contract_rates: {
                ...sourceRates,
                total_freight: isSelected ? sourceRates.total_freight || 0 : 0
              }
            };
          })
        };
      }

      return {
        ...lrfMain,
        lr_list: lrfMain.lr_list.map((lrInner) => ({
          ...lrInner,
          contract_rates: {
            ...(lrfMain?.contract
              ? lrInner.contract_rates
              : lrInner.contract_rates)
          }
        }))
      };
    });

    console.log("transformLrFreight", transformLrFreight,listOfFreight)

    // ✅ fromLoction mein form load locations merge karo (duplicates hato)
    const formLoadFromLocs = formLoadAsLr
      .map(lr => lr.from)
      .filter(f => f.from_city);

    const formLoadToLocs = formLoadAsLr
      .map(lr => lr.to)
      .filter(t => t.to_city);
    // ✅ fromLoction se empty entries hato
    const allFromLocs = [
      ...fromLoction.filter(f => f.from_city),  // ← empty filter
      ...formLoadFromLocs.filter(
        fl => !fromLoction.some(ex => ex.from_city === fl.from_city)
      ),
    ];

    // ✅ toLoction se bhi empty entries hato
    const allToLocs = [
      ...toLoction.filter(t => t.to_city),  // ← empty filter
      ...formLoadToLocs.filter(
        tl => !toLoction.some(ex => ex.to_city === tl.to_city)
      ),
    ];
    // ✅ mergeFreightData ke liye combinedLrList use karo
    // mergeFreightData internally listofLr2 use karta hai — override ke liye temp swap
    const originalListofLr2 = listofLr2;

    // mergeFreightData ko combinedLrList ke saath call karne ke liye
    // inline version use karo
    const mergeFreightDataForSubmit = (lrList, toLocation) => {
      return toLocation.map((toLoc) => {
        const lr_freight = lrList.flatMap((consignorData) => {
          const matchingLrs = (consignorData?.lr_list || []).filter(
            (lr) => lr?.to_location === toLoc?.to_city
          );

          if (matchingLrs.length === 0) return [];

          const chargeable_on = consignorData?.contract?.chargeable_on;

          return matchingLrs.map((lr) => {
            const source = chargeable_on === 1 ? lr?.lr_freight : lr?.contract_rates;

            if (lr?._id) {
              return {
                consignor_id: lr?.consignor_id?._id || '',
                eway_bill_number: lr?.eway_bill_number || '',
                eway_bill_date: lr?.eway_bill_date || '',
                eway_expiry_date: lr?.eway_expiry_date || '',
                freight_type: source?.freight_type,
                qty: source?.qty || 0,
                rate: source?.rate || 0,
                amount: source?.total_freight || 0,
                lr_id: lr?._id || '',
              };
            }

            const lrFromList = combinedLrList.find(l => l === lr) || lr;
            const materialList = (lrFromList?.lr_material_list || []).map((el) => ({
              product_desc: el?.product_desc || "",
              name: el?.product_desc || el?.name || "",
              material_code: el?.material_code || "",
              hsn_code: el?.hsn_code || null,
              material_category_id: el?.material_category_id || null,
              qty: Number(el?.qty) || 0,
              qty_type: el?.qty_type || 1,
              weight: Number(el?.weight) || 0,
              weight_type: el?.weight_type || 1,
              kot: Number(el?.kot) || 0,
              amount: Number(el?.amount) || 0,
            }));

            return {
              consignor_id: lrFromList?.consignor_id?._id || '',
              lr_id: '',
              eway_bill_number: lrFromList?.eway_bill_number || "",
              eway_bill_date: lrFromList?.eway_bill_date || "",
              eway_expiry_date: lrFromList?.eway_expiry_date || "",
              invoice_number: lrFromList?.invoice_number || "",
              mlr_number: lrFromList?.mlr_number || "",
              lr_material_list: materialList,
              total_qty: materialList.reduce((s, e) => s + (Number(e.qty) || 0), 0),
              total_weight: materialList.reduce((s, e) => s + (Number(e.weight) || 0), 0),
              total_kot: materialList.reduce((s, e) => s + (Number(e.kot) || 0), 0),
              total_amount: materialList.reduce((s, e) => s + (Number(e.amount) || 0), 0),
              freight_type: source?.freight_type,
              qty: source?.qty || 0,
              rate: source?.rate || 0,
              amount: source?.total_freight || 0,
            };
          });
        });

        return {
          to_city: toLoc?.to_city,
          to_state: toLoc?.to_state,
          lat: String(toLoc?.lat),
          long: String(toLoc?.long),
          lr_freight
        };
      });
    };

    // ✅ formLoadAsLr ke to_locations ke liye direct freight entries banao
    // const formLoadToLocEntries = formLoadAsLr.map(lr => {
    //   const materialList = (lr?.lr_material_list || []).map((el) => ({
    //     product_desc: el?.product_desc || "",
    //     name: el?.name || "",
    //     material_code: el?.material_code || "",
    //     hsn_code: el?.hsn_code || null,
    //     material_category_id: el?.material_category_id || null,
    //     qty: Number(el?.qty) || 0,
    //     qty_type: el?.qty_type || 1,
    //     weight: Number(el?.weight) || 0,
    //     weight_type: el?.weight_type || 1,
    //     kot: Number(el?.kot) || 0,
    //     amount: Number(el?.amount) || 0,
    //   }));

    //   return {
    //     to_city: lr.to?.to_city || "",
    //     to_state: lr.to?.to_state || "",
    //     lat: String(lr.to?.lat || ""),
    //     long: String(lr.to?.long || ""),
    //     lr_freight: [{
    //       consignor_id: lr?.consignor_id?._id || '',
    //       lr_id: '',
    //       eway_bill_number: lr?.eway_bill_number || "",
    //       eway_bill_date: lr?.eway_bill_date || "",
    //       eway_expiry_date: lr?.eway_expiry_date || "",
    //       invoice_number: lr?.invoice_number || "",
    //       mlr_number: lr?.mlr_number || "",
    //       lr_material_list: materialList,
    //       total_qty: materialList.reduce((s, e) => s + (Number(e.qty) || 0), 0),
    //       total_weight: materialList.reduce((s, e) => s + (Number(e.weight) || 0), 0),
    //       total_kot: materialList.reduce((s, e) => s + (Number(e.kot) || 0), 0),
    //       total_amount: materialList.reduce((s, e) => s + (Number(e.amount) || 0), 0),
    //       freight_type: 6,
    //       qty: 0,
    //       rate: 0,
    //       amount: 0,
    //     }]
    //   };
    // });
const formLoadToLocEntries = formLoadAsLr.map(lr => {
  const materialList = (lr?.lr_material_list || []).map((el) => ({
    product_desc: el?.product_desc || "",
    name: el?.name || "",
    material_code: el?.material_code || "",
    hsn_code: el?.hsn_code || null,
    material_category_id: el?.material_category_id || null,
    qty: Number(el?.qty) || 0,
    qty_type: el?.qty_type || 1,
    weight: Number(el?.weight) || 0,
    weight_type: el?.weight_type || 1,
    kot: Number(el?.kot) || 0,
    amount: Number(el?.amount) || 0,
  }));

  // ✅ transformLrFreight se form load ka freight dhundho
  const consignorId = lr?.consignor_id?._id || '';
  const toCity = lr.to?.to_city || '';
  let freight_type = 6, freightQty = 0, freightRate = 0, freightAmount = 0;

  for (const freightEntry of transformLrFreight) {
    if (freightEntry.consignor_id !== consignorId) continue;
    const matchLr = freightEntry.lr_list?.find(
      l => !l._id && (l.to_location === toCity || l.to?.to_city === toCity)
    );
    if (matchLr?.contract_rates) {
      freight_type = matchLr.contract_rates.freight_type ?? 6;
      freightQty = matchLr.contract_rates.qty || 0;
      freightRate = matchLr.contract_rates.rate || 0;
      freightAmount = matchLr.contract_rates.total_freight || 0;
      break;
    }
  }

  return {
    to_city: lr.to?.to_city || "",
    to_state: lr.to?.to_state || "",
    lat: String(lr.to?.lat || ""),
    long: String(lr.to?.long || ""),
    lr_freight: [{
      consignor_id: lr?.consignor_id?._id || '',
      lr_id: '',
      eway_bill_number: lr?.eway_bill_number || "",
      eway_bill_date: lr?.eway_bill_date || "",
      eway_expiry_date: lr?.eway_expiry_date || "",
      invoice_number: lr?.invoice_number || "",
      mlr_number: lr?.mlr_number || "",
      lr_material_list: materialList,
      total_qty: materialList.reduce((s, e) => s + (Number(e.qty) || 0), 0),
      total_weight: materialList.reduce((s, e) => s + (Number(e.weight) || 0), 0),
      total_kot: materialList.reduce((s, e) => s + (Number(e.kot) || 0), 0),
      total_amount: materialList.reduce((s, e) => s + (Number(e.amount) || 0), 0),
      freight_type,          // ✅ transformLrFreight se aya
      qty: freightQty,       // ✅
      rate: freightRate,     // ✅
      amount: freightAmount, // ✅
    }]
  };
});
    // ✅ existing listOfFreight se modifyLocation banao
    const filteredToLoction = toLoction.filter(t => t.to_city);
    const modifyLocationFromExisting = mergeFreightData(transformLrFreight, filteredToLoction)

    // ✅ form loads ki to_location entries merge karo (duplicate to_city skip karo)
    const mergedToLocations = [
      ...modifyLocationFromExisting,
      ...formLoadToLocEntries.filter(
        fle => !modifyLocationFromExisting.some(
          ex => ex.to_city === fle.to_city
        )
      ),
    ];
console.log("modifyLocationFromExisting",modifyLocationFromExisting)
    // ✅ Agar existing to_city already hai to lr_freight mein push karo
    const finalToLocations = modifyLocationFromExisting.map(existing => {
      console.log("existing",existing)
      const matchingFormLoads = formLoadToLocEntries.filter(
        fle => fle.to_city === existing.to_city
      );
      if (matchingFormLoads.length === 0) return existing;
      return {
        ...existing,
        lr_freight: [
          ...(existing.lr_freight || []),
          ...matchingFormLoads.flatMap(m => m.lr_freight || []),
        ]
      };
    });

    // ✅ jo to_city existing mein nahi thi unhe add karo
    const newToLocations = formLoadToLocEntries.filter(
      fle => !modifyLocationFromExisting.some(ex => ex.to_city === fle.to_city)
    );

    const modifyLocation = [...finalToLocations, ...newToLocations];

    console.log("modifyLocation",modifyLocation,finalToLocations,newToLocations,formLoadToLocEntries)

    const formateChange = (data) => {
      return data?.map((i) => ({
        ...i,
        lat: String(i?.lat),
        long: String(i?.long),
      }));
    };

    let payload = {
      branch_id: formValue?.branch_id,
      company_id: StorageService?.getCompanyId(),
      dispatch_date: utils.convertToISO(formValue?.dispatch_date, true),
      driver_id: formValue?.driver_id || "",
      end_kms: formValue?.end_kms,
      from_location: formateChange(allFromLocs),
      to_location: formateChange(modifyLocation),
      lorry_type_id: formValue?.lorry_type_id,
      route_name: formValue?.route_name,
      start_kms: formValue?.start_kms || "",
      supplier_id: ownerShip == 2 ? formValue?.supplier_id : "",
      vehicle_id: formValue?.vehicle_id,
      vehicle_type_id: formValue?.vehicle_type_id,
      supplier_freight:
        (formTotal.amount == 0 ||
          formTotal.amount == "" ||
          ownerShip != 2) && !(ownerShip == 1 && sameFirm)
          ? null
          : formTotal,
      loading_challi: challiValues,
      ...(dispatchIndent ? { plan_id: dispatchIndent._id } : {}),
    };


     console.log("payload", payload)
    try {
      const res = await dispatch(addTrip(payload));
      if (res?.payload?.responseCode === 200) {
        setLoading(false);
        toast.success(res?.payload?.responseMessage);
        setShowRoutePlanningwithout(false);
        setShow(false);
        setFormValue({ ...getInitialFormState() });
        setSelectedLr([]);
        handleSendMessage(res?.payload?.data?.trip?._id);
        setDispatchIndent('');
      } else if (res?.payload?.responseCode === 400) {
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Failed to submit trip:", error);
    }
  };

  // ============================================================================
  // CALLBACK HANDLERS
  // ============================================================================

  const callbackSelectRoute = (data) => {
    setcallbackDataRoute(data);
    setFormValue({ ...formValue, route_name: data?.route_name });
    setFormLabelValue({
      ...formLabelValue,
      route_name: { ...data, label: data?.route_name },
    });
    getRouteList();
  };

  const callbackSelectLr = async (data) => {
    try {
      let object = {
        consignor_id: data?.consignor_id?._id,
        company_id: StorageService.getCompanyId(),
      };
      const res = await fetchConsignorDetailsData(object);
      if (!!res) {
        setListOfLr2(prev => [...prev, {
          ...data,
          consignor_id: {
            ...res?.data?.consignor_id,
            ...res?.data?.consignor
          }
        }]);
        setSelectedLr2(prev => [...prev, data]);
        setSelectParty(false);
        setIsPickupDrop(false);
      }
    } catch (error) {
      console.error("Failed to select LR:", error);
    }
  };

  const addPartyWithoutLrContinue = async (data) => {

    if (!data?.formValue?.party) return;

    try {
      let object = {
        consignor_id: data?.formValue?.party?.value,
        company_id: StorageService.getCompanyId(),
      };

      const res = await fetchConsignorDetailsData(object);

      if (!!res) {
        const fromObj = {
          from_city: data?.formValueLocation?.from_city?.name,
          from_state: data?.formValueLocation?.from_city?.stateName,
          lat: data?.formValueLocation?.from_city?.latitude,
          long: data?.formValueLocation?.from_city?.longitude
        };

        const toObj = {
          to_city: data?.formValueLocation?.to_city?.name,
          to_state: data?.formValueLocation?.to_city?.stateName,
          lat: data?.formValueLocation?.to_city?.latitude,
          long: data?.formValueLocation?.to_city?.longitude
        };

        const newParty = {
          consignor_id: {
            ...res?.data?.consignor,
            name: data?.formValue?.party?.label,
            _id: data?.formValue?.party?.value,
          },
          from: fromObj,
          from_location: data?.formValueLocation?.from_city.name,
          from_state: data?.formValueLocation?.from_city.stateName,
          to_location: data?.formValueLocation?.to_city.name,
          to_state: data?.formValueLocation?.to_city.stateName,
          to: toObj,
          lr_freight: {
            freight_type: 6,   // Flat Rate — directly amount enter ho sake
            qty: 0,
            rate: 0,
            total_freight: 0,
          },
        };

        setListOfLr2(prev => [...prev, newParty]);
        setSelectedLr2(prev => [...prev, newParty]);
        setSelectParty(false);
        setIsPickupDrop(false);
      }
    } catch (error) {
      console.error("Failed to add party without LR:", error);
    }
  };

  const addPartyWithoutLr = (data) => {
    // // setIsPickupDrop(data);
    // console.log(data)
    addPartyWithoutLrContinue(data)
  };

  const callBackVehicleType = (value) => {
    setFormValue({
      ...formValue,
      lorry_type_id: value?.activeTab?._id,
      vehicle_type_id: value?.tyre?.value,
    });
    setVehicleTypeLabel({
      label: `${value?.activeTab?.lorry_type} > ${value?.tyre?.label}`,
      value: "",
    });
    setVehicleTypeShow(false);
  };

  const addVehicleHandle = (data = true) => {

    setShowOffcanvas(data);
  };

  const addSupplierHandle = (data = true) => {
    setShowOffcanvasSupplier(data);
  };


  const addDriverHandle = (data) => {
    if (ownerShip == 2) {
      setShowOffcanvasMarketDriver(data);
    } else {
      setShowOffcanvasDriver(data);
    }
  };
  const callBackVehicle = (data) => {
    setOwnerShip(data?.vehicle_ownership);
    vehicleHandleChange(data);
    setVehicleStatus(data);
    setRefreshVehicleDropdown(prev => prev + 1);
  };

  const callBackSupplier = (data) => {
    const object = {
      _id: data?._id,
      label: data?.name,
      value: data?._id,
      name: data?.name,
      ...data
    };

    setFormTotal((f) => ({ ...f, tds_diduction: data?.tds_deduction }))
    setFormValue({ ...formValue, supplier_id: data?._id });
    // setFormTotal((f)=>({...f,tds_deduction:data?.tds_deduction}))
    setFormError((pre) => ({ ...pre, supplier_id: "" }))
    setFormLabelValue({ ...formLabelValue, supplier_id: object });
  };

  const callBackDriver = async (data) => {

    setFormValue({ ...formValue, driver_id: data?._id });
    const object = {
      ...data,
      label: data?.name,
      value: data?._id,
    };

    setFormLabelValue({ ...formLabelValue, driver_id: object });
    const newDriverList = [object, ...driverList];
    setDriverList(newDriverList);

    const validationResult = await utils.checkFormError(
      {
        ...formValue,
        ...formTotal,
        driver_id: data?._id,
        manage_trip_kms: vehicleStatus?.manage_trip_kms,
        ownership: ownerShip,
        branchMandetry: formLabelValue?.branch_id?.permission_at_supplier?.supplier_freight?.mandatory,
        loadingChalliMandatory: Number(formLabelValue?.branch_id?.loading_challi?.mandatory) || 0,
        loadingChalli: challiValues,
        marketDriverMandatory: formLabelValue?.branch_id?.market_drive_on_dispatch?.mandatory
      },
      errorSchema.createTripSchima
    );

    if (validationResult === true) {
      setFormError("");
    } else {
      setFormError(validationResult);
    }
  };

  const callBackEnd = async (data) => {
    setOwnerShip(data?.vehicle_id?.vehicle_ownership);
    const vehicleFirmId = data?.vehicle_id?.firm_id?._id;
    const driverFirmId = data?.driver_id?.firm_id?._id;
    const supplierFirmId = data?.supplier_id?.firm_id?._id;
    const branchFirmId = formLabelValue?.branch_id?.firm_id?._id

    let vehicleData = {};
    if (data?.vehicle_id?._id) {
      vehicleData = await getSingleVehicleData(data?.vehicle_id?._id) || {};

    }

    let supplerData = {};
    if (data?.supplier_id?._id) {
      supplerData = await getDataSupplierDetails(data?.supplier_id?._id) || {};
      setFormTotal((f) => ({ ...f, tds_diduction: supplerData?.tds_deduction }))
    }

    let driverData = {};
    if (data?.driver_id?._id) {
      driverData = await getDataDriverDetails(data?.driver_id?._id) || {};

    }


    setFormLabelValue({
      ...formLabelValue,
      vehicle_id: {
        ...vehicleData,
        ...data?.vehicle_id,
        label: `${data?.vehicle_id?.vehicle_no} | ${masterData?.vehicle_ownership[data?.vehicle_id?.vehicle_ownership]
          }`,
        _id: data?.vehicle_id?._id || "",
        vehicle_no: data?.vehicle_id?.vehicle_no || "",
        vehicle_ownership: data?.vehicle_id?.vehicle_ownership || ""
      },
      lorry_type_id: {
        label: data?.lorry_type_id?.lorry_type,
        value: data?.lorry_type_id?._id,
      },
      vehicle_type_id: {
        label: data?.vehicle_type_id?.name,
        value: data?.vehicle_type_id?._id,
      },


      supplier_id: data?.supplier_id?._id && branchFirmId === supplierFirmId
        ? {
          ...data?.supplier_id,
          ...supplerData,
          label: data?.supplier_id?.name,
          value: data?.supplier_id?._id,
          name: data?.supplier_id?.name,
          _id: data?.supplier_id?._id,
        }
        : { label: "", value: "" },

      // ✅ Driver will only be set when firm matches
      driver_id:
        data?.driver_id?._id && vehicleFirmId === driverFirmId
          ? {
            ...driverData,
            ...data?.driver_id,
            label: data?.driver_id?.name,
            value: data?.driver_id?._id,
            name: data?.driver_id?.name,
            _id: data?.driver_id?._id,
          }
          : { label: "", value: "" },
    });

    setFormValue({
      ...formValue,
      lorry_type_id: data?.lorry_type_id?._id,
      vehicle_type_id: data?.vehicle_type_id?._id,
      supplier_id: vehicleStatus?.supplier_id?._id || "",
      driver_id: vehicleStatus?.driver_id?._id || "",
      vehicle_id: data?.vehicle_id?._id,
      start_kms: data?.end_kms,
    });

    setLastReading(data?.end_kms);
    setVehicleTypeLabel({
      label: `${data?.lorry_type_id?.lorry_type} > ${data?.vehicle_type_id?.name}`,
      value: "",
    });


    setRefreshVehicleDropdown(true);

    const validationResult = await utils.checkFormError(
      {
        ...formValue,
        lorry_type_id: data?.lorry_type_id?._id,
        vehicle_type_id: data?.vehicle_type_id?._id,
        supplier_id: data?.supplier_id?._id || "",
        driver_id: vehicleStatus?.driver_id?._id || "",
        vehicle_id: data?.vehicle_id?._id,
        start_kms: data?.end_kms,
      },
      errorSchema.createTripSchima
    );

    setFormError(validationResult);
  };

  const callBackDataLr = (lr) => {
    const modifyLr = { ...lr };

    const initialFunction = async (data) => {
      if (data?.branch_id?._id) {
        if (indexOfLr !== undefined && indexOfLr !== null) {
          // Edit mode — existing update
          setListOfLr2((prev) => {
            const newArr = [...prev];
            if (prev?.[indexOfLr]?.indent_number || prev?.[indexOfLr]?.po_list) {
              newArr[indexOfLr] = {
                ...data,
                indent_number: prev[indexOfLr].indent_number || "",
                po_list: prev[indexOfLr].po_list?.po_number ? prev[indexOfLr].po_list : {}
              };
            } else {
              newArr[indexOfLr] = data;
            }
            return newArr;
          });
          setSelectedLr2((prev) => { const a = [...prev]; a[indexOfLr] = data; return a; });
          setFromLoction((prev) => { const a = [...prev]; a[indexOfLr] = data?.from; return a; });
          setToLoction((prev) => { const a = [...prev]; a[indexOfLr] = data?.to; return a; });
        } else {
          // ✅ New LR — listofLr2 me add karo
          try {
            let object = { consignor_id: data?.consignor_id?._id, company_id: StorageService.getCompanyId() };
            const res = await fetchConsignorDetailsData(object);
            if (!!res) {
              setListOfLr2(prev => [...prev, { ...data, consignor_id: { ...res?.data?.consignor_id, ...res?.data?.consignor } }]);
              setSelectedLr2(prev => [...prev, data]);
              setFromLoction((prev) => [...prev, data?.from]);
              setToLoction((prev) => [...prev, data?.to]);
            }
          } catch (error) {
            console.error("Failed to fetch consignor details:", error);
          }

          // ✅ Form load fields clear karo (id & loadNumber preserve karo)
          // setLoads(prev => prev.map(l =>
          //   l.mode === "form"
          //     ? { id: l.id, loadNumber: l.loadNumber, mode: "form" }  // sirf base fields, baaki clear
          //     : l
          // ));

          clearFormLoad();
        }
      }
    };

    initialFunction(modifyLr);
  };

  const handleAddNewSupplierButtonAction = () => {
    setIsSupplier(false);
    setShowOffcanvasOfSupplier(true);
  };

  const handleAddNewVehicleButtonAction = (data) => {
    setIsDriver(false);
    setShowOffcanvasOfDriver(true);
    setDriverFirmId(data?.firm_id)
  };

  const handleSupplierNextModal = () => {
    setIsSupplier(!isSupplier);
    setShowOffcanvas(true);
  };

  const handleDriverNextModal = () => {
    setIsDriver(!isDriver);
    setShowOffcanvas(true);
  };

  const submitLeaveModalProps = () => {
    navigate("/trip/addtrip");
  };

  const withoutLrSubmit = () => {
    setShowRoutePlanningwithout(true);
    setShowWithOutLrModal(false);
  };

  const submitByWithoutLr = () => {
    onSubmit();
  };

  const onSubmitConsigneeSelect = () => {
    setShowConsigneeMessage(false);
  };

  const onSubmitPartySelect = () => {
    setShowPartyMessage(false);
  };

  // ============================================================================
  // MODAL PROPS CONFIGURATIONS
  // ============================================================================

  const backModalProps = {
    show: showBackModal,
    closeModal: () => setShowBackModal(false),
    title: "Leave This Page",
    submitTitle: "Confirm",
    onSubmit: submitLeaveModalProps,
    confirmModal: "confirmModal",
  };

  const withoutLrModalProps = {
    show: showWithOutLrModal,
    closeModal: () => setShowWithOutLrModal(false),
    title: "Without LR confirmation",
    submitTitle: "Confirm",
    onSubmit: withoutLrSubmit,
    confirmModal: "confirmModal",
    isLoadding: loading,
    disabled: loading
  };

  const firstCreateRouteModal = {
    isOpen: showCreatRoute,
    closeModal: () => setShowCreatRoute(false),
    headerPart: true,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Create Route",
    submitTitle: "Create Route",
    callbackSelectRoute: callbackSelectRoute,
  };

  const selectLrModalProps = {
    isOpen: showSelectLr,
    closeModal: () => setShowSelectLr(false),
    onSubmit: () => setShowSelectLr(false),
    headerPart: false,
    footerPart: true,
    modalMainClass: " _dashCommon_Modal _xxlModal",
    modalTitle: "Select LR",
    submitTitle: "null",
    indexofTable: indexofTable,
    listOfLr: listofLr2,
    callbackSelectLr: callbackSelectLr,
    selectedLr: selectedLr2,
    consignorList: consignorList,
    branchList: branchList,
    setSelectParty: setSelectParty,
    formLabelValue: formLabelValue,
    handlePermissionCallTrip: handlePermissionCallTrip,
    branchFirmId: formLabelValue?.branch_id?.firm_id?._id
  };

  const firstAddLrModal = {
    isOpen: show,
    onSubmit: onSubmit,
    closeModal: () => setShow(false),
    headerPart: true,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _xlModal",
    modalTitle: "LR Freight",
    submitTitle: "Dispatch",
    separateLr: separateLr,
    isLoadding: loading,
    disabled: loading,
    setLoading: setLoading,
    loading: loading,
    setListOfFreight: setListOfFreight,
    listOfFreight: listOfFreight,
    ownerShip: ownerShip,
    formValue: formValue,
  };

  const confirmModalProps = {
    show: confirmModalShow,
    closeModal: () => setConfirmModalShow(false),
    title: "Confirm",
    submitTitle: "Remove",
    onSubmit: handleDelete,
    confirmModal: "confirmModal",
    icon: Images.DELETEICON.default,
  };

  const ewaybillprops = {
    show: ewaybillShow,
    closeModal: () => setEwaybillShow(false),
    title: "Update",
    submitTitle: "Update",
    onSubmit: handleEwayBillUpdate,
    icon: images.EDIT,
    isLoadding: ewayLoading,
    disabled: ewayLoading,
  };

  const vehicleTypeProps = {
    isOpen: vehicleTypeshow,
    closeModal: () => setVehicleTypeShow(false),
    headerPart: true,
    footerPart: true,
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Vehicle Type",
    submitTitle: "Save",
    isLoadding: loading,
    disabled: loading,
    lorryType: lorryType,
    callBackVehicleType: callBackVehicleType,
  };

  const selectPartyModal = {
    isOpen: selectParty,
    closeModal: () => setSelectParty(false),
    addButtonAction: (e) => setIsAddConsignor(e),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Add LR",
    submitTitle: "Add more Details",
    nextModal: (e) => setShowAddLR(e),
    showPrefield: showPrefield,
    showingPrefield: (e) => setShowingPrefield(e),
    secondSubmit: addPartyWithoutLr,
    branchFirmIdForTrip: formLabelValue?.branch_id?.firm_id,
    filledLocation: {
      from: { from_city: "dfdgfg " },
      to: { to_city: "shfdghyf" }
    },


  };


  const pickupDropProps = {
    isOpen: isPickupDrop,
    closeModal: () => setIsPickupDrop(false),
    addButtonAction: (e) => setIsAddConsignor(e),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Pickup/Drop Location",
    submitTitle: "Create & Add LR Later ",
    nextModal: (e) => setShowAddLR(e),
    secondSubmit: addPartyWithoutLrContinue,
  };

  const endTripModal = {
    isOpen: showEndTrip,
    closeModal: () => setShowEndTrip(false),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "End Previous Trip",
    submitTitle: "End Trip",
    callBackEnd: callBackEnd,
    lastTripDetails: lastTripDetails,
    endTripFrom: "Trip",
    dispatchIndent: dispatchIndent
  };

  const makeTruckModal = {
    isOpen: showAvailableTruck,
    closeModal: () => setShowAvailableTruck(false),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Make Truck Available",
    submitTitle: "Mark Available",
  };

  const routePlanModalProps = {
    isOpen: showRoutePlanning,
    closeModal: () => setShowRoutePlanning(false),
    showModalFooter: false,
    modalMainClass: " _dashCommon_Modal _mapModal",
    modalTitle: "Route Planning",
    submitTitle: "Create Trip",
    fromLoction: fromLoction,
    toLoction: toLoction,
    setFromLoction: setFromLoction,
    setToLoction: setToLoction,
    setShow: setShow,
  };

  const routePlanModalWithoutLrProps = {
    isOpen: showRoutePlanningwithout,
    closeModal: () => setShowRoutePlanningwithout(false),
    showModalFooter: false,
    modalMainClass: " _dashCommon_Modal _mapModal",
    modalTitle: "Route Planning",
    submitTitle: "Create Trip",
    fromLoction: fromLoction,
    toLoction: toLoction,
    setFromLoction: setFromLoction,
    setToLoction: setToLoction,
    submitByWithoutLr: submitByWithoutLr,
    loading
  };

  const ebillExpProps = {
    isOpen: modalConfig.isOpen,
    closeModal: () => setModalConfig(prev => ({ ...prev, isOpen: false })),
    onSubmit: () => setModalConfig(prev => ({ ...prev, isOpen: false })),
    modalMainClass: " _dashCommon_Modal __actionPermissionModal _smModal",
    headerPart: true,
    floatCrossBtn: true,
    submitTitle: "Send Enquiry",
    messageType: modalConfig.messageType,
    templateId: modalConfig.templateId,
    templateData: modalConfig.templateData
  };

  const firstShowTripModal = {
    isOpen: showTripInfo,
    onSubmit: () => setShowTripInfo(false),
    closeModal: () => setShowTripInfo(false),
    headerPart: true,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Share Trip Information",
    submitTitle: "Continue",
  };

  const partyMessageModal = {
    isOpen: showPartyMessage,
    onSubmit: onSubmitPartySelect,
    closeModal: () => setShowPartyMessage(false),
    headerPart: true,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Party messages Settings",
    submitTitle: "Continue",
    setAutomessageSelected: setAutomessageSelected,
    automessageSelected: automessageSelected,
    automessage: automessage,
    partyType: "is_consignors",
    parties: automessage?.is_consignors
  };

  const consigneeMessageModal = {
    isOpen: showConsigneeMessage,
    onSubmit: onSubmitConsigneeSelect,
    closeModal: () => setShowConsigneeMessage(false),
    headerPart: true,
    footerPart: false,
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Consignee messages Settings",
    submitTitle: "Continue",
    setAutomessageSelected: setAutomessageSelected,
    automessageSelected: automessageSelected,
    automessage: automessage,
    partyType: "is_consignees",
    parties: automessage?.is_consignees
  };


  useEffect(() => {
    if (formLabelValue?.branch_id?.firm_id?._id != formLabelValue?.vehicle_id?.firm_id?._id) {
      setSameFirm(true)
    } else {
      setFormTotal((pre) => ({ ...pre, amount: 0 }))
      setSameFirm(false)
    }

    if (ownerShip == 2) {
      setFormTotal((pre) => ({ ...pre, amount: 0 }))
      setSameFirm(false)
    }
  }, [formLabelValue?.branch_id?.firm_id?._id, formLabelValue?.vehicle_id?.firm_id?._id])

  useEffect(() => {
    if (formLabelValue?.branch_id?._id && listofLr2.length) {


      const filteredList = listofLr2.filter(lr => {
        // Agar plan_id exist karta hai to filter nahi karna, seedha keep karo
        if (lr.plan_id?._id) {
          return true;
        }
        if (lr._formLoadId) return true;
        // Agar plan_id nahi hai to firm_id check karo
        return lr.firm_id?._id === formLabelValue?.branch_id?.firm_id?._id;
      });

      setListOfLr2(filteredList);
      setSelectedLr2(filteredList)
    }

    if (formLabelValue?.branch_id?._id && formLabelValue?.supplier_id?._id) {

      if (formLabelValue?.branch_id?.firm_id?._id != formLabelValue?.supplier_id?.firm_id?._id) {
        setFormLabelValue((f) => ({ ...f, supplier_id: "" }))
        setFormValue((f) => ({ ...f, supplier_id: "" }))
      }
    }

  }, [formLabelValue?.branch_id?._id]);

  const handleBack = () => {
    navigate("/trip/addtrip")
  }

  const youtubeProps = {
    isOpen: youtubeVideos,
    closeModal: () => setYoutubeVideos((s) => ({ ...s, moduleName: '', moduleAction: false })),
    headerPart: false,
    modalTitle: `Add Trip`,
    submitTitle: `Add Trip`,
    modalMainClass: "_mdModal",
    videosModuleName: constant.Key.trip,
  }

  const handleKmChange = (name, value, handleOnChange) => {
    // Allow empty
    if (value === "") {
      handleOnChange(name, value);
      return;
    }

    // Remove leading zeros like "01" → "1", but keep "0." intact
    if (/^0[0-9]/.test(value)) {
      value = value.replace(/^0+/, "");
    }

    // Allow just "0" or "0."
    if (value === "0" || value === "0.") {
      handleOnChange(name, value);
      return;
    }

    const [intPart, decPart] = value.split(".");

    // Max 9 digits before decimal
    if (intPart && intPart.length > 9) return;

    // If decimal present, max 3 digits after decimal
    if (decPart !== undefined && decPart.length > 3) return;

    // Only allow valid numeric pattern: digits optionally followed by .digits
    if (/^\d+(\.\d{0,3})?$/.test(value)) {
      handleOnChange(name, value);
    }
  };

  console.log(listofLr2, loads)

  // ─── renderFields — actual app components ────────────────────────────────────
  // const renderLoadFields = ({ load }) => (
  //   <>
  //     {/* Eway row */}
  //     <div className="load-form-row eway-row">
  //       <div className="form-field" style={{ flex: 2 }}>
  //         <CommonInput
  //           label="Eway Bill Number"
  //           placeholder="Eway Bill Number"
  //           value={load.ewayBillNumber || ""}
  //           onChange={({ target: { value } }) =>
  //             setLoads(prev => prev.map(l =>
  //               l.id === load.id ? { ...l, ewayBillNumber: value } : l
  //             ))
  //           }
  //           postButton={true}
  //           postButtonLabel="Fetch Details"
  //           onPostButtonClick={() => { /* fetch logic yahan */ }}
  //         />
  //       </div>
  //       {/* ✅ Fetch Details button */}

  //       <div className="form-field">
  //         <CommonDatePicker

  //           placeholder="Eway Bill Start Date"
  //           startDate={load.ewayStartDate || null}
  //           setStartDate={(val) =>
  //             setLoads(prev => prev.map(l =>
  //               l.id === load.id ? { ...l, ewayStartDate: val } : l
  //             ))
  //           }

  //           label="Eway Start Date"
  //           id={Math.random() * 100000}
  //           maxDate={new Date()}


  //         />
  //       </div>
  //       <div className="form-field">
  //         <CommonDatePicker
  //           label="Eway End Date"

  //           id={Math.random() * 10000}
  //           showTimeSelect={false}
  //           defaultTimeFix={true}
  //           minDate={load.ewayStartDate} // {ewayBillStartDate}
  //           placeholder="Eway Bill Expiry Date"
  //           startDate={load.ewayExpiryDate || null}
  //           setStartDate={(val) =>
  //             setLoads(prev => prev.map(l =>
  //               l.id === load.id ? { ...l, ewayExpiryDate: val } : l
  //             ))
  //           }
  //         />
  //       </div>
  //     </div>

  //     {/* Party + Location row */}
  //     <div className="load-form-row party-row">
  //       <div className="form-field">
  //         <CityDropdownForTrip
  //           placeholder="Select Party"
  //           fetchData={fetchConsignorList}
  //           pageSize={20}
  //           onChange={(val) =>
  //             setLoads(prev => prev.map(l =>
  //               l.id === load.id ? { ...l, party: val } : l
  //             ))
  //           }
  //           selectedItem={load.party || null}
  //         />
  //       </div>
  //       <div className="form-field">
  //         <CityDropdownForTrip
  //           placeholder="From Location"
  //           fetchData={fetchCityList}
  //           pageSize={20}
  //           onChange={(val) =>
  //             setLoads(prev => prev.map(l =>
  //               l.id === load.id ? { ...l, fromLocation: val } : l
  //             ))
  //           }
  //           selectedItem={load.fromLocation || null}
  //         />
  //       </div>
  //       <div className="form-field">
  //         <CityDropdownForTrip
  //           placeholder="To Location"
  //           fetchData={fetchCityList}
  //           pageSize={20}
  //           onChange={(val) =>
  //             setLoads(prev => prev.map(l =>
  //               l.id === load.id ? { ...l, toLocation: val } : l
  //             ))
  //           }
  //           selectedItem={load.toLocation || null}
  //         />
  //       </div>
  //       <div className="form-field">
  //         <CommonInput placeholder="MLR Number" value={load.mlrNumber || ""}
  //           onChange={({ target: { value } }) =>
  //             setLoads(prev => prev.map(l =>
  //               l.id === load.id ? { ...l, mlrNumber: value } : l
  //             ))
  //           }
  //         />
  //       </div>
  //       <div className="form-field">
  //         <CommonInput placeholder="Invoice Number" value={load.invoiceNumber || ""}
  //           onChange={({ target: { value } }) =>
  //             setLoads(prev => prev.map(l =>
  //               l.id === load.id ? { ...l, invoiceNumber: value } : l
  //             ))
  //           }
  //         />
  //       </div>
  //     </div>

  //     {/* Item Details row */}
  //     <div className="load-form-row details-row">
  //       {["productDescription", "weight", "quantity", "salesValue", "kot"].map(field => (
  //         <div className="form-field" key={field}>
  //           <CommonInput
  //             placeholder={field.charAt(0).toUpperCase() + field.slice(1).replace(/([A-Z])/g, ' $1')}
  //             value={load[field] || ""}
  //             onChange={({ target: { value } }) =>
  //               setLoads(prev => prev.map(l =>
  //                 l.id === load.id ? { ...l, [field]: value } : l
  //               ))
  //             }
  //           />
  //         </div>
  //       ))}
  //     </div>
  //   </>
  // );

  // ========== renderLoadFields update karo ==========
  // const renderLoadFields = ({ load }) => (
  //   <LoadFormFields
  //     load={load}
  //     setLoads={setLoads}
  //     fetchConsignorList={fetchConsignorList}
  //     fetchCityList={fetchCityList}
  //     onEwayInputClick={() => {
  //       if (!formLabelValue?.branch_id?._id) {
  //         toast.error("Please select a branch first");
  //         return;
  //       }
  //       setActiveLoadId(load.id);
  //       setShowAddEwayModal({
  //         branch_id: {
  //           _id: formLabelValue?.branch_id?._id,
  //           branch: formLabelValue?.branch_id?.branch || formLabelValue?.branch_id?.label,
  //           is_eway_integration: formLabelValue?.branch_id?.is_eway_integration,
  //         },
  //       });
  //     }}
  //   />
  // );

  const renderLoadFields = ({ load }) => (
    <LoadFormFields
      load={load}
      setLoads={setLoads}
      fetchConsignorList={fetchConsignorList}
      fetchCityList={fetchCityList}
      masterData={masterData}
      onEwayInputClick={() => {
        if (!formLabelValue?.branch_id?._id) {
          toast.error("Please select a branch first");
          return;
        }
        setActiveLoadId(load.id);
        setShowAddEwayModal({
          branch_id: {
            _id: formLabelValue?.branch_id?._id,
            branch: formLabelValue?.branch_id?.branch || formLabelValue?.branch_id?.label,
            is_eway_integration: formLabelValue?.branch_id?.is_eway_integration,
          },
        });
      }}
    />
  );
  const handleAddMoreDetails = (id) => {
    const formLoad = loads.find((l) => l.id === id && l.mode === "form");

    if (formLoad) {
      const errors = validateFormLoad(formLoad);

      if (Object.keys(errors).length > 0) {
        setLoads((prev) =>
          prev.map((l) =>
            l.id === formLoad.id ? { ...l, errors } : l
          )
        );
        return;
      }
      setIndexOfLr(null);
      handlePermissionTrip(
        { stopPropagation: () => { } },
        {
          consignor_id: { _id: formLoad.party?._id || formLoad.party?.value || "", ...formLoad.party },
          from_location: formLoad.fromLocation?.name || "",
          from_state: formLoad.fromLocation?.stateName || "",
          to_location: formLoad.toLocation?.name || "",
          to_state: formLoad.toLocation?.stateName || "",
          mlr_number: formLoad.mlrNumber || "",
          invoice_number: formLoad.invoiceNumber || "",
          lr_material_list:
            formLoad.productDescription || formLoad.weight || formLoad.quantity || formLoad.salesValue || formLoad.kot
              ? [{
                product_desc: formLoad.productDescription || "",
                weight: Number(formLoad.weight) || 0,
                weight_type: formLoad.weight_type || 1,  // ← formLoad se
                qty: Number(formLoad.quantity) || 0,
                qty_type: formLoad.qty_type || 1,  // ← formLoad se
                amount: Number(formLoad.salesValue) || 0,
                kot: Number(formLoad.kot) || 0,
                name: "",
                material_code: "",
                hsn_code: null,
                material_category_id: null,
              }]
              : [],
          eway_bill_number: formLoad.ewayBillNumber || null,
          eway_bill_date: formLoad.ewayStartDate || new Date(),
          eway_expiry_date: formLoad.ewayExpiryDate || "",
          lr_id: "",
          isEditLr: false,
          prefill_branch_id: formLabelValue?.branch_id?._id || "",
        },
        null,
        "addLoad"
      );
      return;
    }

    // Display load case
    const index = listofLr2.findIndex((lr, idx) => (lr._id || `temp-${idx}`) === id);
    if (index !== -1) {
      handlePermissionTrip({ stopPropagation: () => { } }, listofLr2[index], index, "addLoad");
    }
  };

  const handleDisplayLoadClick = (id) => {
    const index = listofLr2.findIndex((lr, idx) => (lr._id || `temp-${idx}`) === id);
    if (index !== -1) {
      handlePermissionTrip({ stopPropagation: () => { } }, listofLr2[index], index, "addLoad");
    }
  };

  // ─── Eway Bill Fetch for Form Load ───────────────────────────────────────────
  const handleFetchEwayForFormLoad = async (load) => {
    if (!formLabelValue?.branch_id?._id) {
      toast.error("Please select a branch first");
      return;
    }
    if (!load.ewayBillNumber || load.ewayBillNumber.toString().length !== 12) {
      toast.error("Please enter valid 12 digit eway bill number");
      return;
    }

    // ✅ Loading state set karo
    setLoads((prev) =>
      prev.map((l) => l.id === load.id ? { ...l, ewayFetchLoading: true } : l)
    );

    try {
      await actionPermission({
        company_id: StorageService.getCompanyId(),
        type: constant?.USABILITY_CONFIG_TYPES?.EWAY_FETCH,
        onSuccess: async () => {
          try {
            const res = await getEwayBillLrData({
              branch_id: formLabelValue?.branch_id?._id,
              company_id: StorageService.getCompanyId(),
              ewbNo: load.ewayBillNumber.toString(),
            });

            if (res?.responseCode === 200) {
              const ewayData = res?.data;
              const ewbDetails = ewayData?.ewb_details;

              // ✅ From/To location parse karo
              const fromCity = ewayData?.from_location?.city?.label || "";
              const fromState = ewayData?.from_location?.state?.label || "";
              const toCity = ewayData?.to_location?.city?.label || "";
              const toState = ewayData?.to_location?.state?.label || "";

              // ✅ Material list parse karo
              const materialList = ewayData?.material_list?.length > 0
                ? ewayData.material_list.map((el) => ({
                  product_desc: el?.product_desc || "",
                  name: el?.name || "",
                  material_code: el?.material_code || "",
                  hsn_code: el?.hsn_code || null,
                  material_category_id: el?.material_category_id || null,
                  qty: el?.qty || 0,
                  qty_type: el?.qty_type || 1,
                  weight: el?.weight || 0,
                  weight_type: el?.weight_type || 1,
                  kot: el?.kot || 0,
                  amount: el?.amount || 0,
                }))
                : [];

              // ✅ Eway dates parse karo
              const ewayStartDate = ewbDetails?.ewayBillDate
                ? utils.parseCustomDate(ewbDetails.ewayBillDate)
                : new Date();
              const ewayExpiryDate = ewbDetails?.validUpto
                ? utils.parseCustomDate(ewbDetails.validUpto)
                : "";

              // ✅ Form load me pre-fill karo
              // setLoads((prev) =>
              //   prev.map((l) =>
              //     l.id === load.id
              //       ? {
              //         ...l,
              //         ewayFetchLoading: false,

              //         // Eway details
              //         ewayBillNumber: ewbDetails?.ewbNo ? +ewbDetails.ewbNo : load.ewayBillNumber,
              //         ewayStartDate,
              //         ewayExpiryDate,

              //         // Locations
              //         fromLocation: fromCity
              //           ? { name: fromCity, stateName: fromState, _id: fromCity, label: `${fromCity}, ${fromState}` }
              //           : l.fromLocation,
              //         toLocation: toCity
              //           ? { name: toCity, stateName: toState, _id: toCity, label: `${toCity}, ${toState}` }
              //           : l.toLocation,

              //         // Material
              //         materialListFromEway: materialList,  // alag field me rakho — form fields se alag

              //         // MLR number (transDocNo)
              //         mlrNumber: ewbDetails?.VehiclListDetails?.[0]?.transDocNo || l.mlrNumber,
              //       }
              //       : l
              //   )
              // );

              setLoads((prev) =>
                prev.map((l) =>
                  l.id === load.id
                    ? {
                      ...l,
                      ewayFetchLoading: false,

                      // ✅ Party set from consignor_list
                      party: ewayData?.consignor_list?._id
                        ? {
                          ...ewayData.consignor_list,
                          _id: ewayData.consignor_list._id,
                          value: ewayData.consignor_list._id,
                          label: ewayData.consignor_list.name,
                          name: ewayData.consignor_list.name,
                        }
                        : l.party,

                      ewayBillNumber: ewbDetails?.ewbNo ? +ewbDetails.ewbNo : load.ewayBillNumber,
                      ewayStartDate,
                      ewayExpiryDate,
                      fromLocation: fromCity
                        ? { name: fromCity, stateName: fromState, _id: fromCity, label: `${fromCity}, ${fromState}` }
                        : l.fromLocation,
                      toLocation: toCity
                        ? { name: toCity, stateName: toState, _id: toCity, label: `${toCity}, ${toState}` }
                        : l.toLocation,
                      materialListFromEway: materialList,
                      mlrNumber: ewbDetails?.VehiclListDetails?.[0]?.transDocNo || l.mlrNumber,
                    }
                    : l
                )
              );

              toast.success("Eway bill details fetched successfully");
            } else {
              toast.error(res?.responseMessage || "Failed to fetch eway bill");
              setLoads((prev) =>
                prev.map((l) => l.id === load.id ? { ...l, ewayFetchLoading: false } : l)
              );
            }
          } catch (err) {
            toast.error("Failed to fetch eway bill");
            setLoads((prev) =>
              prev.map((l) => l.id === load.id ? { ...l, ewayFetchLoading: false } : l)
            );
          }
        },
        setModalConfig,
      });
    } catch (err) {
      setLoads((prev) =>
        prev.map((l) => l.id === load.id ? { ...l, ewayFetchLoading: false } : l)
      );
    }
  };


  const handleEwayAction = (e, load, actionType) => {
    e.stopPropagation();
    const originalData = load.originalData;
    const index = load.originalIndex;

    if (actionType === "add" || actionType === "edit") {
      // ✅ LR save hua hai — ewayBillHandle se modal kholo
      ewayBillHandle(e, originalData);
    } else if (actionType === "fetch") {
      // ✅ LR save nahi hua — getConsignorDetails Eway type se
      const fakeEvent = { stopPropagation: () => { } };
      handlePermissionTrip(fakeEvent, originalData, index, "Eway");
    }
  };


  // ========== Modal props ==========
  // const addEwayBillModalProps = {
  //   isOpen: showAddEwayModal,
  //   currentModelClose: true,
  //   isOpenModelClose: () => {
  //     setShowAddEwayModal(false);
  //     setActiveLoadId(null);
  //   },
  //   addButtonAction: (e) => setIsAddConsignor(e),
  //   modalMainClass: "_dashCommon_Modal _mdModal",
  //   modalTitle: "Add Eway Bill",
  //   submitTitle: "Fetch Data",
  //   footerPart: true,

  //   // ✅ Fetch hone ke baad directly load me set karo
  //   fetchNextModal: (ewayData) => {
  //     // AddEwayBillModal se data { eway_bill: {...}, isEditLr: true } shape me aata hai
  //     const data = ewayData?.eway_bill;
  //     const ewbDetails = data?.ewb_details;

  //     if (activeLoadId && data) {
  //       const fromCity = data?.from_location?.city?.label || "";
  //       const fromState = data?.from_location?.state?.label || "";
  //       const toCity = data?.to_location?.city?.label || "";
  //       const toState = data?.to_location?.state?.label || "";

  //       setLoads((prev) =>
  //         prev.map((l) =>
  //           l.id === activeLoadId
  //             ? {
  //                 ...l,
  //                 // Party
  //                 party: data?.consignor_list?._id
  //                   ? {
  //                       ...data.consignor_list,
  //                       _id: data.consignor_list._id,
  //                       value: data.consignor_list._id,
  //                       label: data.consignor_list.name,
  //                       name: data.consignor_list.name,
  //                     }
  //                   : l.party,

  //                 // Eway fields
  //                 ewayBillNumber: ewbDetails?.ewbNo ? +ewbDetails.ewbNo : l.ewayBillNumber,
  //                 ewayStartDate: ewbDetails?.ewayBillDate
  //                   ? utils.parseCustomDate(ewbDetails.ewayBillDate)
  //                   : l.ewayStartDate,
  //                 ewayExpiryDate: ewbDetails?.validUpto
  //                   ? utils.parseCustomDate(ewbDetails.validUpto)
  //                   : l.ewayExpiryDate,

  //                 // Locations
  //                 fromLocation: fromCity
  //                   ? { name: fromCity, stateName: fromState, _id: fromCity, label: `${fromCity}, ${fromState}` }
  //                   : l.fromLocation,
  //                 toLocation: toCity
  //                   ? { name: toCity, stateName: toState, _id: toCity, label: `${toCity}, ${toState}` }
  //                   : l.toLocation,

  //                 // MLR
  //                 mlrNumber: ewbDetails?.VehiclListDetails?.[0]?.transDocNo || l.mlrNumber,

  //                 // Material
  //                 materialListFromEway: data?.material_list || [],
  //               }
  //             : l
  //         )
  //       );
  //     }

  //     // ✅ Sirf modal band karo, koi next modal nahi
  //     setShowAddEwayModal(false);
  //     setActiveLoadId(null);
  //   },

  //   // ✅ Manually bhi sirf band karo
  //   manualNextModal: () => {
  //     setShowAddEwayModal(false);
  //     setActiveLoadId(null);
  //   },

  //   showPrefield: false,
  // };

  const addEwayBillModalProps = {
    isOpen: showAddEwayModal,
    currentModelClose: true,

    // ✅ activeLoadId mat clear karo yahan — EwayBillNewDetailsModal ko chahiye
    isOpenModelClose: () => {
      setShowAddEwayModal(false);
      // ❌ setActiveLoadId(null) — REMOVE karo yahan se
    },

    addButtonAction: (e) => setIsAddConsignor(e),
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Add Eway Bill",
    submitTitle: "Fetch Data",
    footerPart: true,

    // ✅ Step 1 → 2: fetch hone pe EwayBillNewDetailsModal kholo
    fetchNextModal: (ewayData) => {
      setShowEwayDetail(ewayData);
      setShowAddEwayModal(false);
      // ❌ activeLoadId mat clear karo — abhi bhi chahiye
    },

    // ✅ Manually — eway number set karo phir clear karo
    manualNextModal: (ewayBillNo) => {   // ← parameter se lo seedha
      if (activeLoadId && ewayBillNo) {
        setLoads((prev) =>
          prev.map((l) =>
            l.id === activeLoadId
              ? { ...l, ewayBillNumber: String(ewayBillNo) }
              : l
          )
        );
      }
      setShowAddEwayModal(false);
      setActiveLoadId(null);
    },

    showPrefield: false,
  };
  return (
    <>
      {/* {branchList.length > 0 ? ( */}
      <>
        <Heading
          title={"Create Trip"}
          handleBack={handleBack}
          showYouTubeIcon={true}
          youTubeOnClick={(e) => setYoutubeVideos((s) => ({ ...s, moduleName: 'trip_creation', moduleAction: true }))}
        />

        <div className="_addContainer  __nwCreat_trpBx">
          <div className="_midCont_body">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12 col-lg-12 col-xl-10">
                  <div className="_crtDisp_listBx">
                    <div className="">
                      <div className="_fleX_inds">
                        <div className="_divForth">
                          <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                            <CityDropdownForTrip
                              label={"Branch"}
                              placeholder="Select Branch"
                              fetchData={fetchBranch}
                              pageSize={20}
                              onChange={(data) => {
                                handleOnChange("branch_id", data);
                                setFormLabelValue({
                                  ...formLabelValue,
                                  branch_id: data,
                                });
                              }}
                              selectedItem={formLabelValue?.branch_id}
                              error={!!formError.branch_id}
                              errorMessage={formError.branch_id}
                              disabled={dispatchIndent?.branch_id?._id}
                            />
                            {formLabelValue?.branch_id?.firm_id?.firm && <p className='offcanvas_heading_head' style={{ fontWeight: 400, fontSize: "12px", marginLeft: "5px", color: "#4A5565" }}>
                              <img src={FirmImg} className='firm_icon_img' style={{ color: "#4A5565" }} /> {" "}
                              {formLabelValue?.branch_id?.firm_id?.firm && formLabelValue?.branch_id?.firm_id?.firm}
                            </p>}
                          </div>

                        </div>

                        <div className="_divForth">

                          <CommonDatePicker
                            name="dispatch_date"
                            label="Date of Dispatch"
                            startDate={formValue?.dispatch_date}
                            setStartDate={(data) => {
                              handleOnChange("dispatch_date", data);
                              // setStartDate(data);
                            }}
                            error={formError.dispatch_date}
                            value={formLabelValue.dispatch_date}
                            maxDate={new Date()}
                            disabled={formLabelValue?.branch_id?.dispatch_date_time == 1}
                          />
                        </div>
                        <div className="_divForth">

                          <CommonDatePicker
                            name="due_date"
                            label="Due Date"
                            startDate={formValue?.due_date}
                            setStartDate={(data) => {
                              handleOnChange("due_date", data);
                              // setStartDate(data);
                            }}
                            error={formError.due_date}
                            value={formLabelValue.due_date}
                            minDate={formValue?.dispatch_date}
                          />
                        </div>
                        {/* <div className="_divForth">

                        </div> */}


                      </div>
                    </div>

                    <div className="">
                      <h4 className="_disPatch_heads">Dispatch Details</h4>
                      <div className="_fleX_inds">
                        <div className="_divForth __trps_select" style={{ display: "flex", flexDirection: "column", gap: "5px" }}>


                          <VehicleDropdownForTrip
                            label="Vehicle Number"
                            fetchData={fetchVehicle}
                            selectedItem={formLabelValue?.vehicle_id}
                            onChange={(data) => {
                              vehicleStatusCheck(data);

                            }}
                            error={!!formError.vehicle_id}
                            errorMessage={formError.vehicle_id}
                            isAddButton={hasLinkPermission?.canCreate && true}
                            addButtonAction={(e) => addVehicleHandle(e)}
                            pageSize={7}
                            refreshTrigger={refreshVehicleDropdown}
                            onEdit={(item) => {
                              // edit modal/drawer open karo yahan
                              addVehicleHandle(item)
                            }}

                          />
                          {formLabelValue?.vehicle_id?.firm_id?.firm && <p className='offcanvas_heading_head' style={{ fontWeight: 400, fontSize: "12px", marginLeft: "5px", color: "#4A5565" }}>
                            <img src={FirmImg} className='firm_icon_img' style={{ color: "#4A5565" }} /> {" "}
                            {formLabelValue?.vehicle_id?.firm_id?.firm && formLabelValue?.vehicle_id?.firm_id?.firm}
                          </p>}
                        </div>

                        <div
                          className="_divForth"

                        >
                          <div onClick={() => {
                            getDataLorryTypeList()
                            setVehicleTypeShow(true)
                          }}><CustomSelect

                              label="Vehicle Type"
                              placeholder="Select Vehicle Type"
                              options={[
                                { label: "Vehicle Number", value: "123" },
                              ]}
                              value={vehicleTypeLabel}
                              openList={false}
                              error={formError.vehicle_type_id}
                            /></div>

                        </div>

                        {ownerShip == 2 && (
                          <div className="_divForth" style={{ display: "flex", flexDirection: "column", gap: "5px" }}>

                            <CityDropdownForTrip
                              label={"Supplier"}
                              placeholder="Select Supplier"
                              fetchData={fetchSupplier}
                              pageSize={20}
                              onChange={(data) => {
                                handleOnChange("supplier_id", data);
                                setFormLabelValue({
                                  ...formLabelValue,
                                  supplier_id: data,
                                });
                              }}
                              selectedItem={formLabelValue?.supplier_id}
                              isAddButton={hasSupplierLinkPermission?.canCreate ? true : false}
                              // isAddButton={masterChildSupplier?.create === 1 ? (hasSupplierLinkPermission?.canCreate ? true : false) : false}
                              addButtonAction={addSupplierHandle}
                              error={!!formError.supplier_id}
                              errorMessage={formError.supplier_id}
                              onEdit={(item) => {
                                // edit modal open karo
                                addSupplierHandle(item)
                              }}

                            />
                            {formLabelValue?.supplier_id?.firm_id?.firm && <p className='offcanvas_heading_head' style={{ fontWeight: 400, fontSize: "12px", marginLeft: "5px", color: "#4A5565" }}>
                              <img src={FirmImg} className='firm_icon_img' style={{ color: "#4A5565" }} /> {" "}
                              {formLabelValue?.supplier_id?.firm_id?.firm && formLabelValue?.supplier_id?.firm_id?.firm}
                            </p>}
                          </div>
                        )}

                        {/* {(ownerShip == 1 || ownerShip == 3) && ( */}
                        {(ownerShip == 1 || ownerShip == 3 || (ownerShip == 2 && formLabelValue.branch_id?.market_drive_on_dispatch?.view == 1)) && (

                          <div className="_divForth" style={{ display: "flex", flexDirection: "column", gap: "5px" }}>

                            <CityDropdownForTrip
                              label={"Driver"}
                              placeholder="Select Driver"
                              fetchData={fetchDriver}
                              pageSize={20}
                              onChange={(data) => {
                                handleOnChange("driver_id", data);
                                setFormLabelValue({
                                  ...formLabelValue,
                                  driver_id: data,
                                });
                              }}

                              selectedItem={formLabelValue?.driver_id ? formLabelValue?.driver_id : { label: "", value: "" }}
                              isAddButton={masterChildDriver?.create === 1 ? (hasDriverLinkPermission?.canCreate ? true : false) : false}
                              addButtonAction={addDriverHandle}
                              error={!!formError.driver_id}
                              errorMessage={formError.driver_id}
                              onEdit={(item) => {
                                if (formLabelValue?.driver_id?.value) {
                                  addDriverHandle(item);
                                } else {
                                  return null
                                }
                              }}

                            />
                            {(formLabelValue?.vehicle_id?.firm_id?.firm && formLabelValue?.driver_id?.firm_id?.firm) && <p className='offcanvas_heading_head' style={{ fontWeight: 400, fontSize: "12px", marginLeft: "5px", color: "#4A5565" }}>
                              <img src={FirmImg} className='firm_icon_img' style={{ color: "#4A5565" }} /> {" "}
                              {formLabelValue?.driver_id?.firm_id?.firm && formLabelValue?.driver_id?.firm_id?.firm}
                            </p>}
                          </div>
                        )}

                        {(formLabelValue?.vehicle_id?.firm_id?.firm && formLabelValue?.branch_id?.firm_id?.firm
                          && formLabelValue?.vehicle_id?.vehicle_ownership != 2
                          && sameFirm) && <CrossCompanyFreightAlert
                            payableTo={formLabelValue?.vehicle_id?.firm_id?.firm}
                            payableFrom={formLabelValue?.branch_id?.firm_id?.firm}
                            value={formTotal?.amount ? formTotal?.amount : ""}
                            name="amount"
                            onChange={handleFreightOnChange}
                            error={formError?.amount}
                            placeholder="Enter Freight Amount"

                          />}
                      </div>
                    </div>
                    {(branchView && ownerShip == 2) && <div className="">
                      <div style={{ marginBottom: '30px' }}>
                        <div style={{ display: 'flex', gap: "10px" }}> <h4 className="_disPatch_heads">Supplier Freight</h4>


                        </div>
                        <div className='__splNw_tabBx'>
                          {visibleOptions.map((opt) => (
                            <button
                              key={opt.value}
                              className={`__splBtns ${isSelected(opt) ? '__splActive' : ''}`}
                              onClick={() => handleSelectFromButton(opt)}

                            >
                              {opt.label}
                            </button>
                          ))}

                          <div className={`__splSelectBx ${dropdownOptions.find((opt) => opt.value === formTotal?.freight_type) ? "__splActive" : ""}`}>
                            <CustomSelect
                              key={formTotal?.freight_type}
                              options={dropdownOptions}
                              value={
                                dropdownOptions.find((opt) => opt.value === formTotal?.freight_type) || null
                              }
                              onSelect={handleSelectFromDropdown}
                              placeholder={
                                dropdownOptions.find((opt) => opt.value === formTotal?.freight_type)
                                  ? selectedOption.label
                                  : 'More'
                              }

                            />
                          </div>
                        </div>
                      </div>

                      <div className="_fleX_inds">

                        {formTotal.freight_type !== 6 && <div className="_divForth" style={{ display: 'flex', gap: '10px' }}>
                          <div className="clmDual_fx">
                            <CommonInput
                              type="text"
                              name="qty"
                              value={formTotal.qty}
                              onChange={({ target: { name, value } }) => {
                                // if (/^(?!0\d)\d*(\.\d{0,2})?$/.test(value) || value === '') {
                                //   handleFreightOnChange(name, value);
                                // }
                                if (/^0[1-9]/.test(value)) {
                                  value = value.replace(/^0+/, ''); // "01" → "1", "05" → "5"
                                }

                                // Allow "0." for decimals
                                if (value === "0" || value === "0.") {

                                  handleFreightOnChange(name, value);

                                  return;
                                }

                                if (/^(?!0\d)\d*(\.\d{0,2})?$/.test(value) || value === '') {

                                  handleFreightOnChange(name, value);

                                }
                              }}
                              label={
                                freightTypeList.length
                                  ? freightTypeList?.find(
                                    (i) => i?.value === formTotal?.freight_type
                                  ).label
                                  : "Qty"
                              }

                              focus={!!formError?.qty}
                              error={formError.qty}
                              maxLength={4}
                            />
                          </div>
                          <div className="clmDual_fx">
                            <CommonInput
                              type="text"
                              label="Rate"
                              name="rate"
                              value={formTotal.rate}
                              onChange={({ target: { name, value } }) => {

                                // Remove leading zeros like 01, 05 → 1, 5
                                if (/^0[0-9]+/.test(value) && !value.includes(".")) {
                                  value = value.replace(/^0+/, '');
                                }

                                // Allow empty
                                if (value === "") {
                                  handleFreightOnChange(name, value);
                                  return;
                                }

                                // Allow 0 and 0.
                                if (value === "0" || value === "0.") {
                                  handleFreightOnChange(name, value);
                                  return;
                                }

                                // Allow numbers with up to 2 decimal places
                                const decimalRegex = /^(?!0\d)\d*(\.\d{0,2})?$/;

                                if (decimalRegex.test(value)) {
                                  handleFreightOnChange(name, value);
                                }
                              }}

                              focus={!!formError?.rate}
                              error={formError.rate}
                              maxLength={4}
                            />
                          </div>
                        </div>}
                        <div className="_divForth">
                          <CommonInput
                            type="text"
                            onChange={({ target: { name, value } }) => {

                              // Remove leading zeros like 01, 05 → 1, 5
                              if (/^0[0-9]+/.test(value) && !value.includes(".")) {
                                value = value.replace(/^0+/, '');
                              }

                              // Allow empty
                              if (value === "") {
                                handleFreightOnChange(name, value);
                                return;
                              }

                              // Allow 0 and 0.
                              if (value === "0" || value === "0.") {
                                handleFreightOnChange(name, value);
                                return;
                              }

                              // Allow numbers with up to 2 decimal places
                              const decimalRegex = /^(?!0\d)\d*(\.\d{0,2})?$/;

                              if (decimalRegex.test(value)) {
                                handleFreightOnChange(name, value);
                              }
                            }}

                            label={
                              "Total Freight"
                            }
                            placeholder="Enter Freight"
                            value={formTotal?.amount ? formTotal?.amount : ""}
                            name="amount"
                            disabled={formTotal?.freight_type !== 6}
                            focus={!!formError?.amount}
                            error={formError.amount}
                            maxLength={7}
                          />
                        </div>
                        <div className="_divForth"><CustomSelect
                          label="TDS Deduction %"
                          value={
                            tdsList?.find(
                              (i) => i?.value === formTotal?.tds_diduction
                            )

                          }
                          options={tdsList}
                          onSelect={(data) => {
                            handleFreightOnChange("tds_diduction", data?.value);
                          }}
                          focus={!!formError?.tds_diduction}
                          error={formError.tds_diduction}
                          disabled={formLabelValue?.supplier_id?.tds_deduction}
                        />
                        </div>

                      </div>
                    </div>}
                    <div className="mb-3">
                      {vehicleStatus?.manage_trip_kms !== undefined &&
                        vehicleStatus?.manage_trip_kms != 0 && (
                          <h4 className="_disPatch_heads">
                            Truck Running Details
                          </h4>
                        )
                      }
                      {vehicleStatus?.manage_trip_kms !== undefined &&
                        vehicleStatus?.manage_trip_kms != 0 && (
                          <div className="_fleX_inds">
                            <div className="_divForth">
                              <CommonInput
                                type="text"
                                label="Start Kms"
                                name="start_kms"

                                // onChange={({ target: { name, value } }) => {
                                //   if (/^0[0-9]/.test(value)) {
                                //     value = value.replace(/^0+/, ''); // "01" → "1"
                                //   }

                                //   // Allow "0." for decimals but not "0x" where x is digit
                                //   if (value === "0") {
                                //     handleOnChange(name, value);
                                //     return;
                                //   }
                                //   handleOnChange(name, value)
                                // }}
                                onChange={({ target: { name, value } }) =>
                                  handleKmChange(name, value, handleOnChange)
                                }
                                onKeyDown={(e) => handleKeyDown(e, 3)}
                                value={formValue?.start_kms}
                                // onKeyDown={handleKeyDown}
                                error={formError.start_kms}
                                maxLength={13}
                              />
                              <p className="_bottomPLine pt-1">
                                Last Odometer Reading{" "}
                                <span>
                                  {lastReading
                                    ? `${lastReading} km`
                                    : "Not Found"}
                                </span>
                              </p>
                            </div>
                          </div>
                        )
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {formLabelValue?.branch_id?._id && <div className="container-fluid ">
              <div className=" ">
                <h4 className="_disPatch_heads">
                  LR Details
                </h4>
                <div className="col-md-12 col-lg-12 col-xl-12">
                  <div className='__loadLr_detailBx'>

                    {/* <div className='d-flex gap-4 mb-3'>
                      {
                        constant.LR_loads?.map((el, ind) => {
                          return (
                            <div className="checkBx_lv p-0">
                              <React.Fragment>
                                <input
                                  className="form-check-input"
                                  id={`load_dispatch_${`${el.value}load`}`}
                                  type="radio"
                                  name="pay_type_load"
                                  checked={Number(loadDispatch) === Number(el?.value)}
                                  value={el.value}
                                  onChange={({ target: { value } }) => {
                                    setLoadDispatch(value);
                                  }}
                                />
                                <label htmlFor={`load_dispatch_${`${el.value}load`}`} className="form-check-label">
                                  {el.label}
                                </label>
                              </React.Fragment>
                            </div>
                          )
                        })
                      }
                    </div> */}

                    {/* {loadDispatch == 1 && <div className='__loadLr_table'>
                      <table>
                        <thead>
                          <tr>
                            <th>Loads</th>
                            <th>Party Detail</th>
                            <th>From- To Location</th>
                            <th>LR Detail</th>
                            <th>Item Details</th>
                            <th>Eway Details</th>
                            <th>Indent Details</th>
                          </tr>
                        </thead>

                        <tbody>
                          {
                            listofLr2?.length ? (
                              <>
                                {listofLr2 &&
                                  listofLr2.length
                                  ? listofLr2?.map(
                                    (i, index1) => {
                                      return <tr style={{ cursor: "pointer" }} onClick={(e) => getConsignorDetails(e, i, index1, "all")}>
                                        <td onClick={(e) => getConsignorDetails(e, i, index1, "loadindex")}><p className="load-txt">{`Load ${index1 + 1}`}</p></td>
                                        <td onClick={(e) => getConsignorDetails(e, i, index1, "party")}><div className='__dotTxt_1Line'><p>{i?.consignor_id?.name || ""}</p></div></td>
                                        <td>
                                          <div className='mb-1'>
                                            <p>{i?.from?.from_city || ""}</p>
                                            {i?.unit_id
                                              ?.name ? <span>
                                              {i?.unit_id
                                                ?.code
                                                ? i?.unit_id
                                                  ?.code
                                                : " -"}{" "}
                                              {i?.unit_id
                                                ?.code && i?.unit_id
                                                  ?.name ? " | " : ""}
                                              {i?.unit_id
                                                ?.name
                                                ? i?.unit_id
                                                  ?.name
                                                : " -"}
                                            </span> : <button className='__adxConsignee' onClick={(e) => getConsignorDetails(e, i, index1, "unit")} disabled={consignorLoading[`unit_${index1}`]}>{consignorLoading[`unit_${index1}`] ? "Adding Unit.." : "Add Unit"}</button>}
                                            <span> {i?.unit_id?.zone_id?.name ? `Zone - ${i?.unit_id?.zone_id?.name}` : ""}</span>
                                          </div>

                                          <div>
                                            <p>{i?.to?.to_city || ""}</p>
                                            {i?.consignee_id
                                              ?.name ? <span>{i?.consignee_id
                                                ?.code
                                                ? i?.consignee_id
                                                  ?.code
                                                : " -"}{" "}
                                              {i?.consignee_id
                                                ?.code && i?.consignee_id
                                                  ?.name ? " | " : ""}
                                              {i?.consignee_id
                                                ?.name
                                                ? i?.consignee_id
                                                  ?.name
                                                : " -"}</span> : <button className='__adxConsignee' onClick={(e) => getConsignorDetails(e, i, index1, "consignee")} disabled={consignorLoading[`consignee_${index1}`]}>{consignorLoading[`consignee_${index1}`] ? "Adding Consignee.." : "Add Consignee"}</button>}
                                            <span>{i?.consignee_id?.zone_id?.name ? `Zone - ${i?.consignee_id?.zone_id?.name}` : ""}</span>
                                          </div>
                                        </td>
                                        <td>
                                          {i?.lr_number || i?.invoice_number || i?.invoice_date || i?.mlr_number ? <div className='__lrDetail_lodFx'>
                                            <div className='__lrDetail_lodInr'>
                                              <span>LR Date</span>
                                              <p>{i?.invoice_date ? moment(
                                                i?.invoice_date
                                              ).format(
                                                " DD/MM/YYYY"
                                              ) : "-"}</p>
                                            </div>
                                            <div className='__lrDetail_lodInr'>
                                              <span>Invoice Number</span>
                                              <p onClick={(e) =>
                                                i?.invoice_number && getConsignorDetails(e, i, index1, "unit")
                                              }> {i?.invoice_number
                                                ? i?.invoice_number
                                                : "-"}</p>
                                            </div>
                                            <div className='__lrDetail_lodInr'>
                                              <span>LR Number</span>
                                              <p onClick={(e) =>
                                                i?.lr_number && getConsignorDetails(e, i, index1, "unit")
                                              }>{i?.lr_number
                                                ? `${i?.lr_number}`
                                                : "-"}</p>
                                            </div>
                                            <div className='__lrDetail_lodInr'>
                                              <span>MLR Number</span>
                                              <p onClick={(e) =>
                                                i?.mlr_number && getConsignorDetails(e, i, index1, "unit")
                                              }>{i?.mlr_number
                                                ? `${i?.mlr_number}`
                                                : "-"}</p>
                                            </div>
                                          </div> : <button className='__advLr_btn' onClick={(e) => handlePermissionTrip(e, i, index1, "addLoad")} disabled={consignorLoading[`addLoad_${index1}`]}>
                                            {consignorLoading[`addLoad_${index1}`] ? "Load Data..." : "Add Load Details"}
                                            {i?.consignor_id?.permission_at_dispatch?.lr_mandatory == 1 && <span style={{ color: 'red', display: 'inline', opacity: '1' }}>*</span>}</button>}
                                        </td>

                                        <td>
                                          {i?.lr_material_list?.length > 0 ? <>
                                            <div className='d-flex mb-1'>
                                              <span style={{ flex: '0 0 90px' }}>KOT</span>
                                              <p>{utils.getTotalAmount(i?.lr_material_list, 'kot')}</p>
                                            </div>
                                            <div className='d-flex mb-1'>
                                              <span style={{ flex: '0 0 90px' }}>QTY</span>
                                              <p>{utils.getTotalAmount(i?.lr_material_list, 'qty')}</p>
                                            </div>
                                            <div className='d-flex mb-1'>
                                              <span style={{ flex: '0 0 90px' }}>Sales Value</span>
                                              <p>{utils.getTotalAmount(i?.lr_material_list, 'amount')}</p>
                                            </div>
                                            <div className='d-flex'>
                                              <span style={{ flex: '0 0 90px' }}>Weight</span>
                                              <p style={{ whiteSpace: 'nowrap' }}>
                                                {utils.getTotalAmount(i?.lr_material_list, 'weight')}{' '}

                                                {
                                                  masterData?.material_weight_type[i?.lr_material_list[index1]?.weight_type]
                                                }
                                              </p>

                                            </div>
                                          </> :
                                            <button className='__advLr_btn' onClick={(e) => handlePermissionTrip(e, i, index1, "additem")} disabled={consignorLoading[`additem_${index1}`]}>
                                              {consignorLoading[`additem_${index1}`] ? "Load Data..." : "Add Item Details"} {i?.consignor_id?.permission_at_item?.item?.mandatory == 1 && <span style={{ color: 'red', display: 'inline', opacity: '1' }}>*</span>}</button>

                                          }
                                        </td>
                                        <td>
                                          {i.eway_bill_number !== undefined ? <><div className='mb-2'>
                                            <span>Eway Number (Manual)</span>

                                            {i?.eway_bill_number != null ? <p>{i?.eway_bill_number || ""}</p> : <button
                                              className="__adxConsignee"
                                              onClick={(e) =>
                                                ewayBillHandle(e,
                                                  i
                                                )
                                              }
                                            >
                                              + Add Eway
                                              Bill
                                              {i?.consignor_id?.permission_at_dispatch?.eway_bill_mandatory == 1 && <span style={{ color: 'red', display: 'inline', opacity: '1' }}>*</span>}</button>}
                                          </div>
                                            <div>
                                              <span>Expiry Date</span>
                                              <p>{i?.eway_expiry_date ? moment(
                                                i?.eway_expiry_date
                                              ).format(
                                                " DD/MM/YYYY"
                                              ) : "-"}</p>
                                            </div></> : <button className='__advLr_btn' onClick={(e) => getConsignorDetails(e, i, index1, "Eway")} disabled={consignorLoading[`Eway_${index1}`]}>
                                            {consignorLoading[`Eway_${index1}`] ? "Load Data..." : "Add Eway Bill"}
                                            {i?.consignor_id?.permission_at_dispatch?.eway_bill_mandatory == 1 && <span style={{ color: 'red', display: 'inline', opacity: '1' }}>*</span>}</button>
                                          }

                                        </td>
                                        <td>
                                          {i?.indent_number || i?.po_number ? <>
                                            <div className='mb-2'>
                                              {i?.indent_number && <span>Indent Number</span>}
                                              <p>{i?.indent_number ? `#${i?.indent_number || ""}` : "-"}</p>
                                            </div>
                                            <div>
                                              {i?.po_number && <span>PO Number</span>}
                                              <p>{i?.po_number || "-"}</p>
                                            </div>
                                          </> : <span style={{ textAlign: "center" }} >{"-"}</span>}


                                          <div className='__loadClose_btnBx'>
                                            {!i?.plan_id?._id && <button className='__loadClose_btn' onClick={(e) => {
                                              handleDelteSubmit(e,
                                                i,
                                                index1,
                                              );
                                            }}>
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="56"
                                                height="29"
                                                viewBox="0 0 56 29"
                                                fill="none"
                                              >
                                                <rect
                                                  x="56"
                                                  y="29"
                                                  width="56"
                                                  height="29"
                                                  rx="14.5"
                                                  transform="rotate(180 56 29)"
                                                  fill="#434343"
                                                />
                                                <path
                                                  d="M41.9806 10.2104C41.9162 10.1458 41.8396 10.0946 41.7554 10.0596C41.6711 10.0247 41.5807 10.0067 41.4895 10.0067C41.3983 10.0067 41.3079 10.0247 41.2237 10.0596C41.1394 10.0946 41.0629 10.1458 40.9984 10.2104L37.592 13.6098L34.1856 10.2034C34.1211 10.1389 34.0446 10.0878 33.9603 10.0529C33.876 10.018 33.7857 10 33.6945 10C33.6033 10 33.513 10.018 33.4287 10.0529C33.3445 10.0878 33.2679 10.1389 33.2034 10.2034C33.1389 10.2679 33.0878 10.3445 33.0529 10.4287C33.018 10.513 33 10.6033 33 10.6945C33 10.7857 33.018 10.876 33.0529 10.9603C33.0878 11.0446 33.1389 11.1211 33.2034 11.1856L36.6098 14.592L33.2034 17.9984C33.1389 18.0629 33.0878 18.1395 33.0529 18.2237C33.018 18.308 33 18.3983 33 18.4895C33 18.5807 33.018 18.671 33.0529 18.7553C33.0878 18.8396 33.1389 18.9161 33.2034 18.9806C33.2679 19.0451 33.3445 19.0963 33.4287 19.1312C33.513 19.1661 33.6033 19.184 33.6945 19.184C33.7857 19.184 33.876 19.1661 33.9603 19.1312C34.0446 19.0963 34.1211 19.0451 34.1856 18.9806L37.592 15.5742L40.9984 18.9806C41.0629 19.0451 41.1395 19.0963 41.2237 19.1312C41.308 19.1661 41.3983 19.184 41.4895 19.184C41.5807 19.184 41.671 19.1661 41.7553 19.1312C41.8396 19.0963 41.9161 19.0451 41.9806 18.9806C42.0451 18.9161 42.0963 18.8396 42.1312 18.7553C42.1661 18.671 42.184 18.5807 42.184 18.4895C42.184 18.3983 42.1661 18.308 42.1312 18.2237C42.0963 18.1395 42.0451 18.0629 41.9806 17.9984L38.5742 14.592L41.9806 11.1856C42.2453 10.9209 42.2453 10.4751 41.9806 10.2104Z"
                                                  fill="white"
                                                />
                                              </svg>
                                            </button>}
                                          </div>
                                        </td>
                                      </tr>
                                    }
                                  )
                                  : <tr></tr>}
                              </>
                            ) : (
                              ""
                            )}
                          <tr>
                            <td colSpan={7} style={{ paddingBlock: '11px' }}>
                              <div className='lrDeatilsTrip ' style={{ justifyContent: listofLr2?.length ? "" : "center" }}>
                                {lrPermissions?.create === 1 && <button className='_addComm_btn' disabled={modalConfig?.isLoadding} onClick={() => {
                                  handlePermissionCallTrip();

                                }}>Add New LR</button>}
                                <button className='_addComm_btn' onClick={() => {
                                  setShowSelectLr(true);
                                }}>Add Existing LR</button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>} */}

                    <Loadlrcomponent
                      loads={loads}
                      onRemoveLoad={handleRemoveLoad}
                      onAddMoreLoads={handleAddMoreLoads}
                      onAddExistingLR={() => setShowSelectLr(true)}
                      onAddMoreDetails={handleAddMoreDetails}
                      onDisplayLoadClick={handleDisplayLoadClick}
                      onEwayAction={handleEwayAction}
                      renderFields={renderLoadFields}
                      canRemoveLoad={(load) => {
                        // Display loads ke liye originalData?.plan_id check karo
                        if (load.mode === "display") {
                          return !load.originalData?.plan_id?._id;
                        }
                        // Form loads hamesha removable hain
                        return true;
                      }}
                    />
                  </div>
                </div>
                {/* </>
                  ))} */}
              </div>
            </div>}


            {formLabelValue?.branch_id?.loading_challi?.view == 1 && <div className="container-fluid pt-5">
              <div style={{ display: "flex", gap: "10px", alignContent: "center" }}><h4 className="_disPatch_heads mb-2">Loading Challi </h4> <span style={{ display: "flex", gap: "10px", alignContent: "center", fontSize: "15px", marginTop: "2px" }}> Total Qty : {totalQty}</span></div><LoadingChalli values={challiValues}
                onChange={handleChalliChange} mandatory={formLabelValue?.branch_id?.loading_challi?.mandatory} /></div>}
            {!!formError.loadingChalli && (
              <div style={{ color: "red", fontSize: 12, marginTop: 4, fontWeight: 500 }}>
                {formError.loadingChalli}
              </div>
            )}

          </div>
        </div>

        <div className="__sharBottomFix">
          <div className="__sharFlx">
            <h4 className="_disPatch_heads mb-0">
              <span style={{ color: '#60D669', fontSize: '20px', marginRight: '5px' }}><IoLogoWhatsapp /></span>
              Share Trip Information
            </h4>
            <button className="__vwTem_btn" onClick={() => setShowTripInfo(true)}>View Template</button>
          </div>

          <div className="__trpFlwx_fr">
            <div className='_dLass' style={{ minWidth: 'auto' }} onClick={() => setShowPartyMessage(true)}>
              <CommonCheckbox
                type="checkbox"
                name={`Party (${automessageSelected?.is_consignors.length})`}
                id='__party'
                isChecked={automessageSelected?.is_consignors.length}
                handleClick={(e) => {
                  if (!e.target.checked) {

                  }
                }}
              />
            </div>

            <div className='_dLass' style={{ minWidth: 'auto' }} onClick={() => setShowConsigneeMessage(true)}>
              <CommonCheckbox
                type="checkbox"
                name={`Consignee (${automessageSelected?.is_consignees.length})`}
                id="__consigee"
                isChecked={automessageSelected?.is_consignees.length}
                handleClick={(e) => {
                  if (!e.target.checked) {

                  }

                }}
              />
            </div>

            <div className='_dLass' style={{ minWidth: 'auto' }}>
              <CommonCheckbox
                type="checkbox"
                name="Supplier"
                id="__supplier"
                disabled={!formValue?.supplier_id || isSupplierCheckboxDisabled}
                isChecked={automessageSelected?.is_supplier.length}
                handleClick={(e) => handleSupplierCheckbox(e)}
              />
            </div>
          </div>
        </div>

        <div className="bottomFix">
          <button
            onClick={() => onValidationCheck()}
            className="_addComm_btn"
            type="button"

          >
            Dispatch Trip{" "}
          </button>

        </div>

        {show && <LrFreightModal2 {...firstAddLrModal} />}

        {showCreatRoute && <AddRouteModal {...firstCreateRouteModal} />}
        {showSelectLr && <SelectLrModal2 {...selectLrModalProps} />}
        {confirmModalShow && (
          <ConfirmModalFor {...confirmModalProps}>
            <>
              <p className="_confirmPrx">
                {" "}
                Are you sure you want to delete  {LrDetele.title} {" "}
              </p>
            </>
          </ConfirmModalFor>
        )}
        {ewaybillShow && (
          <ConfirmModalFor {...ewaybillprops}>
            <>
              <div className="colFlx">
                <div className="_addRouts_flex">
                  <CommonDatePicker
                    name="dispatch_date"
                    label="Date of Dispatch"
                    startDate={ewayForm?.start_date}
                    setStartDate={(data) => {
                      handleChange("start_date", data);
                    }}
                    error={formError?.start_date}
                    focus={formError?.start_date}
                  />
                  <CommonDatePicker
                    name="dispatch_date"
                    label="Date of Dispatch"
                    startDate={ewayForm?.end_date}
                    setStartDate={(data) => {
                      handleChange("end_date", data);
                    }}
                    error={formError?.end_date}
                    focus={formError?.end_date}
                  />
                </div>
                <CommonInput
                  label="Eway bill number"
                  placeholder="Enter Number"
                  name="eway_bill_number"
                  onChange={({ target: { name, value } }) =>
                    handleChange(name, value)
                  }
                  maxLength={12}
                  value={ewayForm?.eway_bill_number}
                  onKeyDown={handleKeyDown}
                  error={formError?.eway_bill_number}
                  focus={formError?.eway_bill_number}
                />
              </div>
            </>
          </ConfirmModalFor>
        )}
        {vehicleTypeshow && <VehicleTypeModal {...vehicleTypeProps} />}

        <div
          className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvas ? "show" : ""
            }`}
          tabIndex={-1}
          style={{ visibility: showOffcanvas ? "visible" : "hidden" }}
        >
          {showOffcanvas && (
            <AddEditVehicleModal
              isOpen={showOffcanvas}
              onClose={() => setShowOffcanvas(false)}
              callBackVehicle={callBackVehicle}
              isSupplier={isSupplier}
              isDriver={isDriver}
              handleAddNewSupplierButtonAction={
                handleAddNewSupplierButtonAction
              }
              handleAddNewVehicleButtonAction={
                handleAddNewVehicleButtonAction
              }
              // hideAddNewOption={false}
              branchFirmId={formLabelValue?.branch_id?.firm_id}
              titleText="trip"

            />
          )}
        </div>

        <div className={showOffcanvas ? "offBack_drop" : ""}></div>

        {/* Supplier Canvas Open and Vahicle canvas will close */}
        <div
          className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasOfSupplier ? "show" : ""
            }`}
          tabIndex={-1}
          style={{
            visibility: showOffcanvasOfSupplier ? "visible" : "hidden",
          }}
        >
          {showOffcanvasOfSupplier && (
            <AddEditSupplier
              isOpen={showOffcanvasOfSupplier}
              onClose={(e) => setShowOffcanvasOfSupplier(false)}
              callBackSupplier={(e) => handleSupplierNextModal(e)}
              hideAddNewOption={false}
              branchFirmId={formLabelValue?.branch_id?.firm_id}
            />
          )}
        </div>
        <div className={showOffcanvasOfSupplier ? "offBack_drop" : ""}></div>

        {/* Driver Canvas Open and Vahicle canvas will close */}
        <div
          className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasOfDriver ? "show" : ""
            }`}
          tabIndex={-1}
          style={{ visibility: showOffcanvasOfDriver ? "visible" : "hidden" }}
        >
          {showOffcanvasOfDriver && (
            <AddEditOwnDriver
              isOpen={showOffcanvasOfDriver}
              onClose={() => setShowOffcanvasOfDriver(false)}
              callBackDriver={(e) => handleDriverNextModal(e)}
              hideAddNewOption={false}
              vehicleFirmId={driverFirmId}
            />
          )}
        </div>
        <div className={showOffcanvasOfDriver ? "offBack_drop" : ""}></div>

        <div
          className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasSupplier ? "show" : ""
            }`}
          tabIndex={-1}
          style={{ visibility: showOffcanvasSupplier ? "visible" : "hidden" }}
        >
          {showOffcanvasSupplier && (
            <AddEditSupplier
              isOpen={showOffcanvasSupplier}
              onClose={() => setShowOffcanvasSupplier(false)}
              callBackSupplier={callBackSupplier}
              branchFirmId={formLabelValue?.branch_id?.firm_id}
              hideAddNewOption={false}
            />
          )}
        </div>
        <div className={showOffcanvasSupplier ? "offBack_drop" : ""}></div>
        <div
          className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasDriver ? "show" : ""
            }`}
          tabIndex={-1}
          style={{ visibility: showOffcanvasDriver ? "visible" : "hidden" }}
        >
          {showOffcanvasDriver && (
            <AddEditOwnDriver
              isOpen={showOffcanvasDriver}
              onClose={(e) => setShowOffcanvasDriver(false)}
              callBackDriver={callBackDriver}
              vehicleFirmId={formLabelValue?.vehicle_id?.firm_id}
              hideAddNewOption={false}
            />
          )}
        </div>
        <div className={showOffcanvasDriver ? "offBack_drop" : ""}></div>
        <div
          className={`offcanvas offcanvas-end common_offCanvas ${showOffcanvasMarketDriver ? "show" : ""
            }`}
          tabIndex={-1}
          style={{ visibility: showOffcanvasMarketDriver ? "visible" : "hidden" }}
        >
          {showOffcanvasMarketDriver && (
            <AddEditMarketDriver
              isOpen={showOffcanvasMarketDriver}
              onClose={(e) => setShowOffcanvasMarketDriver(false)}
              callBackDriver={callBackDriver}
              hideAddNewOption={false}
              branchFirmId={formLabelValue?.vehicle_id?.firm_id}

            />
          )}
        </div>

        <div className={showOffcanvasMarketDriver ? "offBack_drop" : ""}></div>

        <div
          className={`offcanvas offcanvas-end common_offCanvas addLr_xxl_Offcanvas ${showLrDetail ? "show" : ""
            }`}
          tabIndex={-1}
          style={{ visibility: showLrDetail ? "visible" : "hidden" }}
        >
          {showLrDetail && (
            <LrDetailModal
              isOpen={showLrDetail}
              onClose={(e) => setShowLrDetail(false)}
              nextModal={(e) => handleNextModal(e)}
              createTripBtn={true}

            />
          )}
        </div>
        <div className={showLrDetail ? "offBack_drop" : ""}></div>

        {selectParty && <AddLrModal {...selectPartyModal} />}
        {isPickupDrop && <AddPickUpDrop {...pickupDropProps} />}

        <div
          className={`offcanvas offcanvas-end common_offCanvas addLr_xxl_Offcanvas ${showAddLR ? "show" : ""
            }`}
          tabIndex={-1}
          style={{ visibility: showAddLR ? "visible" : "hidden" }}
        >
          {showAddLR && (
            <AddEditLrModal
              isOpen={showAddLR}
              onClose={() => { setShowAddLR(false); setIndexOfLr(null); }
              }
              callBackDataLr={callBackDataLr}
              type="from_trip"
              callGetData={() => { }}

            />
          )}
        </div>
        <div className={showAddLR ? 'offBack_drop' : ''} ></div>

        <div
          className={`offcanvas offcanvas-end common_offCanvas slidedOffCanvas ${lrModalToggleForEway?.ewayModal ? "open" : ""}`}
          tabIndex={-1}
          style={{ visibility: lrModalToggleForEway?.ewayModal ? "visible" : "hidden", zIndex: lrModalToggleForEway?.ewayModal ? 10000 : 1045 }}
        >
          {lrModalToggleForEway?.ewayModal &&
            <FetchEwayBillLrModal
              isOpen={lrModalToggleForEway}
              onClose={() => setLrModalToggleForEway(false)}
              fetchNextModal={(e) => setShowAddLR(e)}
            />}
        </div>

        <div className={lrModalToggleForEway?.ewayModal ? 'offBack_drop' : ''} style={{ zIndex: lrModalToggleForEway?.ewayModal ? 9999 : 999 }}></div>

        {showEndTrip && <EndTripModal {...endTripModal} />}

        {showAvailableTruck && (
          <MakeTruckAvailableModal {...makeTruckModal} />
        )}
      </>
      {/* ) : (
        <div colSpan="100%" className="loaderBg" style={{ textAlign: "center" }}> <Loading /></div>

      )} */}

      <input ref={hiddenInputRef} type="hidden" />
      {showBackModal && (
        <ConfirmModalFor {...backModalProps}>
          <>
            <p className="_confirmPrx"> Do you really want leave this Page ?</p>
          </>
        </ConfirmModalFor>
      )}

      {showWithOutLrModal && (
        <ConfirmModalFor {...withoutLrModalProps}>
          <>
            <p className="_confirmPrx"> Do you really want dispatch Trip without LR ? </p>
          </>
        </ConfirmModalFor>
      )}

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${isAddConsignor ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: isAddConsignor ? "visible" : "hidden" }}
      >
        {isAddConsignor && (
          <AddEditConsignor
            isOpen={isAddConsignor}
            onClose={() => setIsAddConsignor(false)}
            isPreviousModal={(e) => setSelectParty(true)}
            showingPrefield={(e) => setShowingPrefield(true)}
            hideAddNewOption={false}
            branchFirmId={formLabelValue?.branch_id?.firm_id?._id ? formLabelValue?.branch_id?.firm_id?._id : StorageService?.getFirmId()}
          />
        )}
      </div>

      <div className={isAddConsignor ? "offBack_drop" : ""}></div>

      {showRoutePlanning && <RoutePanningModal {...routePlanModalProps} />}
      {showRoutePlanningwithout && <RoutePanningWithoutLrModal {...routePlanModalWithoutLrProps} />}
      {modalConfig.isOpen && <EbillExtentionModal
        {...ebillExpProps}
      />}

      {showTripInfo
        && (
          <TripInfoModal {...firstShowTripModal} />
        )
      }

      {showPartyMessage
        && (
          <PartymessageModal {...partyMessageModal} />
        )
      }

      {showConsigneeMessage
        && (
          <PartymessageModal {...consigneeMessageModal} />
        )
      }

      {
        (youtubeVideos?.moduleName === 'trip_creation' && youtubeVideos?.moduleAction === true)
        && (
          <YoutubeModal {...youtubeProps} />
        )
      }

      {/* Step 1: AddEwayBillModal */}
      {showAddEwayModal && <AddEwayBillModal {...addEwayBillModalProps} />}

      {/* Step 2: EwayBillNewDetailsModal offcanvas */}
      <div
        className={`offcanvas offcanvas-end common_offCanvas slidedOffCanvas ${showEwayDetail ? "open" : ""} ${isEwayClosing ? "closing" : ""}`}
        tabIndex={-1}
        style={{ visibility: showEwayDetail || isEwayClosing ? "visible" : "hidden" }}
      >
        {showEwayDetail && (
          <EwayBillNewDetailsModal
            isOpen={showEwayDetail}
            onClose={() => {
              // ✅ Cancel pe FetchEwayBillLrModal na khule
              setLrModalToggleForEway(false);
              setIsEwayClosing(true);
              setTimeout(() => {
                setShowEwayDetail(false);
                setIsEwayClosing(false);
                setActiveLoadId(null);
              }, 300);
            }}
            // fetchNextModal={(data) => {
            //   const ewayBill = data?.eway_bill;
            //   const ewbDetails = ewayBill?.ewb_details;

            //   if (activeLoadId && ewayBill) {

            //     // ✅ From location — ewb_details > from_location.city label
            //     const fromCity =
            //       ewbDetails?.fromPlace ||
            //       ewayBill?.from_location?.city?.label ||
            //       ewayBill?.from_location?.name ||
            //       "";
            //     const fromState =
            //       utils?.codeToStateName?.[ewbDetails?.fromStateCode] ||
            //       ewayBill?.from_location?.state?.label ||
            //       "";

            //     // ✅ To location — ewb_details > to_location.city label
            //     const toCity =
            //       ewbDetails?.toPlace ||
            //       ewayBill?.to_location?.city?.label ||
            //       ewayBill?.to_location?.name ||
            //       "";
            //     const toState =
            //       utils?.codeToStateName?.[ewbDetails?.toStateCode] ||
            //       ewayBill?.to_location?.state?.label ||
            //       "";

            //     setLoads((prev) =>
            //       prev.map((l) =>
            //         l.id === activeLoadId
            //           ? {
            //             ...l,

            //             // ✅ Party — consignor_list se
            //             party: ewayBill?.consignor_list?._id
            //               ? {
            //                 ...ewayBill.consignor_list,
            //                 _id: ewayBill.consignor_list._id,
            //                 value: ewayBill.consignor_list._id,
            //                 label: ewayBill.consignor_list.name,
            //                 name: ewayBill.consignor_list.name,
            //               }
            //               : l.party,

            //             // ✅ Eway number
            //             ewayBillNumber: ewbDetails?.ewbNo
            //               ? +ewbDetails.ewbNo
            //               : l.ewayBillNumber,

            //             // ✅ Eway dates
            //             ewayStartDate: ewbDetails?.ewayBillDate
            //               ? utils.parseCustomDate(ewbDetails.ewayBillDate)
            //               : l.ewayStartDate,
            //             ewayExpiryDate: ewbDetails?.validUpto
            //               ? utils.parseCustomDate(ewbDetails.validUpto)
            //               : l.ewayExpiryDate,

            //             // ✅ From location
            //             fromLocation: fromCity
            //               ? {
            //                 name: fromCity,
            //                 stateName: fromState,
            //                 _id: fromCity,
            //                 label: `${fromCity}, ${fromState}`,
            //               }
            //               : l.fromLocation,

            //             // ✅ To location
            //             toLocation: toCity
            //               ? {
            //                 name: toCity,
            //                 stateName: toState,
            //                 _id: toCity,
            //                 label: `${toCity}, ${toState}`,
            //               }
            //               : l.toLocation,

            //             // ✅ MLR number — transDocNo se
            //             mlrNumber:
            //               ewbDetails?.VehiclListDetails?.[0]?.transDocNo ||
            //               l.mlrNumber,

            //             // ✅ Invoice number — docNo se
            //             invoiceNumber: ewbDetails?.docNo || l.invoiceNumber,

            //             // ✅ Material list
            //             materialListFromEway: ewayBill?.material_list || [],
            //           }
            //           : l
            //       )
            //     );
            //   }

            //   // ✅ Detail modal band karo
            //   setIsEwayClosing(true);
            //   setTimeout(() => {
            //     setShowEwayDetail(false);
            //     setIsEwayClosing(false);
            //     setActiveLoadId(null);
            //   }, 300);
            // }}

            // AFTER ✅  (fetchNextModal in showEwayDetail offcanvas)
            fetchNextModal={async (data) => {
              const ewayBill = data?.eway_bill;
              const ewbDetails = ewayBill?.ewb_details;

              // ✅ Locations
              const fromCity = ewbDetails?.fromPlace || ewayBill?.from_location?.city?.label || "";
              const fromState = utils?.codeToStateName?.[ewbDetails?.fromStateCode] || ewayBill?.from_location?.state?.label || "";
              const toCity = ewbDetails?.toPlace || ewayBill?.to_location?.city?.label || "";
              const toState = utils?.codeToStateName?.[ewbDetails?.toStateCode] || ewayBill?.to_location?.state?.label || "";

              // ✅ Eway dates
              const ewayBillDate = ewbDetails?.ewayBillDate ? utils.parseCustomDate(ewbDetails.ewayBillDate) : new Date();
              const ewayExpiryDate = ewbDetails?.validUpto ? utils.parseCustomDate(ewbDetails.validUpto) : "";

              // ✅ Material list
              const materialList = ewayBill?.material_list?.length > 0
                ? ewayBill.material_list.map((el) => ({
                  product_desc: el?.product_desc || "",
                  name: el?.name || "",
                  material_code: el?.material_code || "",
                  hsn_code: el?.hsn_code || null,
                  material_category_id: el?.material_category_id || null,
                  qty: el?.qty || 0,
                  qty_type: el?.qty_type || 1,
                  weight: el?.weight || 0,
                  weight_type: el?.weight_type || 1,
                  kot: el?.kot || 0,
                  amount: el?.amount || 0,
                }))
                : [];

              // ✅ createNewLr API payload
              const payload = {
                company_id: StorageService.getCompanyId(),
                branch_id: formLabelValue?.branch_id?._id || "",
                consignor_id: data?._id || ewayBill?.consignor_list?._id || "",
                from_location: fromCity,
                from_state: fromState,
                to_location: toCity,
                to_state: toState,
                unit_id: ewayBill?.from_location?._id || "",
                consignee_id: ewayBill?.to_location?._id || "",
                eway_bill_number: ewbDetails?.ewbNo ? +ewbDetails.ewbNo : null,
                eway_bill_date: ewayBillDate,
                eway_expiry_date: ewayExpiryDate,
                lr_material_list: materialList,
                invoice_number: ewbDetails?.docNo || "",
                mlr_number: ewbDetails?.VehiclListDetails?.[0]?.transDocNo || "",
                invoice_date: new Date(),
                invoice_time: new Date().toLocaleString("en-US", { timeStyle: "short" }),
                freight_type: "",
                total_qty: "",
                rate: "",
                total_amount: "",
                attachment_file: [],
                remarks: "",
              };

              try {
                const res = await createNewLr(payload);

                if (res?.responseCode === 200) {
                  const savedLr = res?.data?.lr;
                  toast.success("LR Created Successfully");

                  // ✅ Saved LR ko listofLr2 me add karo
                  // consignor details merge karo taaki display row sahi dikhe
                  const lrWithConsignor = {
                    ...savedLr,
                    consignor_id: {
                      ...data,           // permissions, firm_id etc
                      _id: data?._id,
                      name: data?.name || ewayBill?.consignor_list?.name,
                    },
                    from: {
                      from_city: fromCity,
                      from_state: fromState,
                      lat: String(ewayBill?.from_location?.lat || ""),
                      long: String(ewayBill?.from_location?.long || ""),
                    },
                    to: {
                      to_city: toCity,
                      to_state: toState,
                      lat: String(ewayBill?.to_location?.lat || ""),
                      long: String(ewayBill?.to_location?.long || ""),
                    },
                  };

                  setListOfLr2(prev => [...prev, lrWithConsignor]);
                  setSelectedLr2(prev => [...prev, lrWithConsignor]);

                  // ✅ Jis form load pe eway click hua tha use remove karo
                  if (activeLoadId) {
                    handleRemoveLoad(activeLoadId);
                  }
                } else {
                  toast.error(res?.responseMessage || "LR create failed");
                }
              } catch (err) {
                console.error("LR create error:", err);
                toast.error("LR create failed");
              }

              // ✅ Modal band karo
              setIsEwayClosing(true);
              setTimeout(() => {
                setShowEwayDetail(false);
                setIsEwayClosing(false);
                setActiveLoadId(null);
              }, 300);
            }}
          />
        )}
      </div>
      <div className={showEwayDetail || isEwayClosing ? "offBack_drop" : ""}></div>
    </>
  );
};

export default CreateTrip3;



